System.register(["./dyn-index.js", "./dyn-jsx-runtime.js"], function(exports, module) {
  "use strict";
  var React, reactExports;
  return {
    setters: [(module2) => {
      React = module2.R;
      reactExports = module2.r;
    }, null],
    execute: function() {
      exports({
        a: generateUtilityClasses,
        b: composeClasses,
        c: createTheme$1,
        d: capitalize,
        e: darken,
        f: alpha,
        g: generateUtilityClass,
        j: getOverlayAlpha,
        k: resolveBreakpointValues,
        l: lighten,
        n: createUnarySpacing,
        o: deepmerge,
        p: handleBreakpoints,
        q: getValue,
        r: resolveProps,
        u: useDefaultProps
      });
      const common = {
        black: "#000",
        white: "#fff"
      };
      const red = {
        300: "#e57373",
        400: "#ef5350",
        500: "#f44336",
        700: "#d32f2f",
        800: "#c62828"
      };
      const purple = {
        50: "#f3e5f5",
        200: "#ce93d8",
        300: "#ba68c8",
        400: "#ab47bc",
        500: "#9c27b0",
        700: "#7b1fa2"
      };
      const blue = {
        50: "#e3f2fd",
        200: "#90caf9",
        400: "#42a5f5",
        700: "#1976d2",
        800: "#1565c0"
      };
      const lightBlue = {
        300: "#4fc3f7",
        400: "#29b6f6",
        500: "#03a9f4",
        700: "#0288d1",
        900: "#01579b"
      };
      const green = {
        300: "#81c784",
        400: "#66bb6a",
        500: "#4caf50",
        700: "#388e3c",
        800: "#2e7d32",
        900: "#1b5e20"
      };
      const orange = {
        300: "#ffb74d",
        400: "#ffa726",
        500: "#ff9800",
        700: "#f57c00",
        900: "#e65100"
      };
      const grey = {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#eeeeee",
        300: "#e0e0e0",
        400: "#bdbdbd",
        500: "#9e9e9e",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#212121",
        A100: "#f5f5f5",
        A200: "#eeeeee",
        A400: "#bdbdbd",
        A700: "#616161"
      };
      function formatMuiErrorMessage(code, ...args) {
        const url = new URL(`https://mui.com/production-error/?code=${code}`);
        args.forEach((arg2) => url.searchParams.append("args[]", arg2));
        return `Minified MUI error #${code}; visit ${url} for the full message.`;
      }
      const THEME_ID = exports("h", "$$material");
      function _extends() {
        return _extends = Object.assign ? Object.assign.bind() : function(n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = arguments[e];
            for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }
          return n;
        }, _extends.apply(null, arguments);
      }
      function sheetForTag(tag) {
        if (tag.sheet) {
          return tag.sheet;
        }
        for (var i = 0; i < document.styleSheets.length; i++) {
          if (document.styleSheets[i].ownerNode === tag) {
            return document.styleSheets[i];
          }
        }
        return void 0;
      }
      function createStyleElement(options) {
        var tag = document.createElement("style");
        tag.setAttribute("data-emotion", options.key);
        if (options.nonce !== void 0) {
          tag.setAttribute("nonce", options.nonce);
        }
        tag.appendChild(document.createTextNode(""));
        tag.setAttribute("data-s", "");
        return tag;
      }
      var StyleSheet = /* @__PURE__ */ function() {
        function StyleSheet2(options) {
          var _this = this;
          this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
              if (_this.insertionPoint) {
                before = _this.insertionPoint.nextSibling;
              } else if (_this.prepend) {
                before = _this.container.firstChild;
              } else {
                before = _this.before;
              }
            } else {
              before = _this.tags[_this.tags.length - 1].nextSibling;
            }
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
          };
          this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
          this.tags = [];
          this.ctr = 0;
          this.nonce = options.nonce;
          this.key = options.key;
          this.container = options.container;
          this.prepend = options.prepend;
          this.insertionPoint = options.insertionPoint;
          this.before = null;
        }
        var _proto = StyleSheet2.prototype;
        _proto.hydrate = function hydrate(nodes) {
          nodes.forEach(this._insertTag);
        };
        _proto.insert = function insert(rule) {
          if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
            this._insertTag(createStyleElement(this));
          }
          var tag = this.tags[this.tags.length - 1];
          if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
              sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {
            }
          } else {
            tag.appendChild(document.createTextNode(rule));
          }
          this.ctr++;
        };
        _proto.flush = function flush() {
          this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
          });
          this.tags = [];
          this.ctr = 0;
        };
        return StyleSheet2;
      }();
      var MS = "-ms-";
      var MOZ = "-moz-";
      var WEBKIT = "-webkit-";
      var COMMENT = "comm";
      var RULESET = "rule";
      var DECLARATION = "decl";
      var IMPORT = "@import";
      var KEYFRAMES = "@keyframes";
      var LAYER = "@layer";
      var abs = Math.abs;
      var from = String.fromCharCode;
      var assign = Object.assign;
      function hash(value, length2) {
        return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
      }
      function trim(value) {
        return value.trim();
      }
      function match(value, pattern) {
        return (value = pattern.exec(value)) ? value[0] : value;
      }
      function replace(value, pattern, replacement) {
        return value.replace(pattern, replacement);
      }
      function indexof(value, search) {
        return value.indexOf(search);
      }
      function charat(value, index) {
        return value.charCodeAt(index) | 0;
      }
      function substr(value, begin, end) {
        return value.slice(begin, end);
      }
      function strlen(value) {
        return value.length;
      }
      function sizeof(value) {
        return value.length;
      }
      function append(value, array) {
        return array.push(value), value;
      }
      function combine(array, callback) {
        return array.map(callback).join("");
      }
      var line = 1;
      var column = 1;
      var length = 0;
      var position = 0;
      var character = 0;
      var characters = "";
      function node(value, root, parent, type, props, children, length2) {
        return { value, root, parent, type, props, children, line, column, length: length2, return: "" };
      }
      function copy(root, props) {
        return assign(node("", null, null, "", null, null, 0), root, { length: -root.length }, props);
      }
      function char() {
        return character;
      }
      function prev() {
        character = position > 0 ? charat(characters, --position) : 0;
        if (column--, character === 10)
          column = 1, line--;
        return character;
      }
      function next() {
        character = position < length ? charat(characters, position++) : 0;
        if (column++, character === 10)
          column = 1, line++;
        return character;
      }
      function peek() {
        return charat(characters, position);
      }
      function caret() {
        return position;
      }
      function slice(begin, end) {
        return substr(characters, begin, end);
      }
      function token(type) {
        switch (type) {
          // \0 \t \n \r \s whitespace token
          case 0:
          case 9:
          case 10:
          case 13:
          case 32:
            return 5;
          // ! + , / > @ ~ isolate token
          case 33:
          case 43:
          case 44:
          case 47:
          case 62:
          case 64:
          case 126:
          // ; { } breakpoint token
          case 59:
          case 123:
          case 125:
            return 4;
          // : accompanied token
          case 58:
            return 3;
          // " ' ( [ opening delimit token
          case 34:
          case 39:
          case 40:
          case 91:
            return 2;
          // ) ] closing delimit token
          case 41:
          case 93:
            return 1;
        }
        return 0;
      }
      function alloc(value) {
        return line = column = 1, length = strlen(characters = value), position = 0, [];
      }
      function dealloc(value) {
        return characters = "", value;
      }
      function delimit(type) {
        return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
      }
      function whitespace(type) {
        while (character = peek())
          if (character < 33)
            next();
          else
            break;
        return token(type) > 2 || token(character) > 3 ? "" : " ";
      }
      function escaping(index, count) {
        while (--count && next())
          if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
            break;
        return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
      }
      function delimiter(type) {
        while (next())
          switch (character) {
            // ] ) " '
            case type:
              return position;
            // " '
            case 34:
            case 39:
              if (type !== 34 && type !== 39)
                delimiter(character);
              break;
            // (
            case 40:
              if (type === 41)
                delimiter(type);
              break;
            // \
            case 92:
              next();
              break;
          }
        return position;
      }
      function commenter(type, index) {
        while (next())
          if (type + character === 47 + 10)
            break;
          else if (type + character === 42 + 42 && peek() === 47)
            break;
        return "/*" + slice(index, position - 1) + "*" + from(type === 47 ? type : next());
      }
      function identifier(index) {
        while (!token(peek()))
          next();
        return slice(index, position);
      }
      function compile(value) {
        return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
      }
      function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
        var index = 0;
        var offset = 0;
        var length2 = pseudo;
        var atrule = 0;
        var property = 0;
        var previous = 0;
        var variable = 1;
        var scanning = 1;
        var ampersand = 1;
        var character2 = 0;
        var type = "";
        var props = rules;
        var children = rulesets;
        var reference = rule;
        var characters2 = type;
        while (scanning)
          switch (previous = character2, character2 = next()) {
            // (
            case 40:
              if (previous != 108 && charat(characters2, length2 - 1) == 58) {
                if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
                  ampersand = -1;
                break;
              }
            // " ' [
            case 34:
            case 39:
            case 91:
              characters2 += delimit(character2);
              break;
            // \t \n \r \s
            case 9:
            case 10:
            case 13:
            case 32:
              characters2 += whitespace(previous);
              break;
            // \
            case 92:
              characters2 += escaping(caret() - 1, 7);
              continue;
            // /
            case 47:
              switch (peek()) {
                case 42:
                case 47:
                  append(comment(commenter(next(), caret()), root, parent), declarations);
                  break;
                default:
                  characters2 += "/";
              }
              break;
            // {
            case 123 * variable:
              points[index++] = strlen(characters2) * ampersand;
            // } ; \0
            case 125 * variable:
            case 59:
            case 0:
              switch (character2) {
                // \0 }
                case 0:
                case 125:
                  scanning = 0;
                // ;
                case 59 + offset:
                  if (ampersand == -1) characters2 = replace(characters2, /\f/g, "");
                  if (property > 0 && strlen(characters2) - length2)
                    append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
                  break;
                // @ ;
                case 59:
                  characters2 += ";";
                // { rule/at-rule
                default:
                  append(reference = ruleset(characters2, root, parent, index, offset, rules, points, type, props = [], children = [], length2), rulesets);
                  if (character2 === 123)
                    if (offset === 0)
                      parse(characters2, root, reference, reference, props, rulesets, length2, points, children);
                    else
                      switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                        // d l m s
                        case 100:
                        case 108:
                        case 109:
                        case 115:
                          parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                          break;
                        default:
                          parse(characters2, reference, reference, reference, [""], children, 0, points, children);
                      }
              }
              index = offset = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
              break;
            // :
            case 58:
              length2 = 1 + strlen(characters2), property = previous;
            default:
              if (variable < 1) {
                if (character2 == 123)
                  --variable;
                else if (character2 == 125 && variable++ == 0 && prev() == 125)
                  continue;
              }
              switch (characters2 += from(character2), character2 * variable) {
                // &
                case 38:
                  ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
                  break;
                // ,
                case 44:
                  points[index++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
                  break;
                // @
                case 64:
                  if (peek() === 45)
                    characters2 += delimit(next());
                  atrule = peek(), offset = length2 = strlen(type = characters2 += identifier(caret())), character2++;
                  break;
                // -
                case 45:
                  if (previous === 45 && strlen(characters2) == 2)
                    variable = 0;
              }
          }
        return rulesets;
      }
      function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length2) {
        var post = offset - 1;
        var rule = offset === 0 ? rules : [""];
        var size = sizeof(rule);
        for (var i = 0, j = 0, k = 0; i < index; ++i)
          for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
            if (z = trim(j > 0 ? rule[x] + " " + y : replace(y, /&\f/g, rule[x])))
              props[k++] = z;
        return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length2);
      }
      function comment(value, root, parent) {
        return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
      }
      function declaration(value, root, parent, length2) {
        return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
      }
      function serialize(children, callback) {
        var output = "";
        var length2 = sizeof(children);
        for (var i = 0; i < length2; i++)
          output += callback(children[i], i, children, callback) || "";
        return output;
      }
      function stringify(element, index, children, callback) {
        switch (element.type) {
          case LAYER:
            if (element.children.length) break;
          case IMPORT:
          case DECLARATION:
            return element.return = element.return || element.value;
          case COMMENT:
            return "";
          case KEYFRAMES:
            return element.return = element.value + "{" + serialize(element.children, callback) + "}";
          case RULESET:
            element.value = element.props.join(",");
        }
        return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
      }
      function middleware(collection) {
        var length2 = sizeof(collection);
        return function(element, index, children, callback) {
          var output = "";
          for (var i = 0; i < length2; i++)
            output += collection[i](element, index, children, callback) || "";
          return output;
        };
      }
      function rulesheet(callback) {
        return function(element) {
          if (!element.root) {
            if (element = element.return)
              callback(element);
          }
        };
      }
      function memoize$1(fn) {
        var cache = /* @__PURE__ */ Object.create(null);
        return function(arg2) {
          if (cache[arg2] === void 0) cache[arg2] = fn(arg2);
          return cache[arg2];
        };
      }
      var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index) {
        var previous = 0;
        var character2 = 0;
        while (true) {
          previous = character2;
          character2 = peek();
          if (previous === 38 && character2 === 12) {
            points[index] = 1;
          }
          if (token(character2)) {
            break;
          }
          next();
        }
        return slice(begin, position);
      };
      var toRules = function toRules2(parsed, points) {
        var index = -1;
        var character2 = 44;
        do {
          switch (token(character2)) {
            case 0:
              if (character2 === 38 && peek() === 12) {
                points[index] = 1;
              }
              parsed[index] += identifierWithPointTracking(position - 1, points, index);
              break;
            case 2:
              parsed[index] += delimit(character2);
              break;
            case 4:
              if (character2 === 44) {
                parsed[++index] = peek() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
              }
            // fallthrough
            default:
              parsed[index] += from(character2);
          }
        } while (character2 = next());
        return parsed;
      };
      var getRules = function getRules2(value, points) {
        return dealloc(toRules(alloc(value), points));
      };
      var fixedElements = /* @__PURE__ */ new WeakMap();
      var compat = function compat2(element) {
        if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
        // negative .length indicates that this rule has been already prefixed
        element.length < 1) {
          return;
        }
        var value = element.value;
        var parent = element.parent;
        var isImplicitRule = element.column === parent.column && element.line === parent.line;
        while (parent.type !== "rule") {
          parent = parent.parent;
          if (!parent) return;
        }
        if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
          return;
        }
        if (isImplicitRule) {
          return;
        }
        fixedElements.set(element, true);
        var points = [];
        var rules = getRules(value, points);
        var parentRules = parent.props;
        for (var i = 0, k = 0; i < rules.length; i++) {
          for (var j = 0; j < parentRules.length; j++, k++) {
            element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
          }
        }
      };
      var removeLabel = function removeLabel2(element) {
        if (element.type === "decl") {
          var value = element.value;
          if (
            // charcode for l
            value.charCodeAt(0) === 108 && // charcode for b
            value.charCodeAt(2) === 98
          ) {
            element["return"] = "";
            element.value = "";
          }
        }
      };
      function prefix(value, length2) {
        switch (hash(value, length2)) {
          // color-adjust
          case 5103:
            return WEBKIT + "print-" + value + value;
          // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
          case 5737:
          case 4201:
          case 3177:
          case 3433:
          case 1641:
          case 4457:
          case 2921:
          // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
          case 5572:
          case 6356:
          case 5844:
          case 3191:
          case 6645:
          case 3005:
          // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
          case 6391:
          case 5879:
          case 5623:
          case 6135:
          case 4599:
          case 4855:
          // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
          case 4215:
          case 6389:
          case 5109:
          case 5365:
          case 5621:
          case 3829:
            return WEBKIT + value + value;
          // appearance, user-select, transform, hyphens, text-size-adjust
          case 5349:
          case 4246:
          case 4810:
          case 6968:
          case 2756:
            return WEBKIT + value + MOZ + value + MS + value + value;
          // flex, flex-direction
          case 6828:
          case 4268:
            return WEBKIT + value + MS + value + value;
          // order
          case 6165:
            return WEBKIT + value + MS + "flex-" + value + value;
          // align-items
          case 5187:
            return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
          // align-self
          case 5443:
            return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
          // align-content
          case 4675:
            return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
          // flex-shrink
          case 5548:
            return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
          // flex-basis
          case 5292:
            return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
          // flex-grow
          case 6060:
            return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
          // transition
          case 4554:
            return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
          // cursor
          case 6187:
            return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
          // background, background-image
          case 5495:
          case 3959:
            return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
          // justify-content
          case 4968:
            return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
          // (margin|padding)-inline-(start|end)
          case 4095:
          case 3583:
          case 4068:
          case 2532:
            return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
          // (min|max)?(width|height|inline-size|block-size)
          case 8116:
          case 7059:
          case 5753:
          case 5535:
          case 5445:
          case 5701:
          case 4933:
          case 4677:
          case 5533:
          case 5789:
          case 5021:
          case 4765:
            if (strlen(value) - 1 - length2 > 6) switch (charat(value, length2 + 1)) {
              // (m)ax-content, (m)in-content
              case 109:
                if (charat(value, length2 + 4) !== 45) break;
              // (f)ill-available, (f)it-content
              case 102:
                return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
              // (s)tretch
              case 115:
                return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
            }
            break;
          // position: sticky
          case 4949:
            if (charat(value, length2 + 1) !== 115) break;
          // display: (flex|inline-flex)
          case 6444:
            switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
              // stic(k)y
              case 107:
                return replace(value, ":", ":" + WEBKIT) + value;
              // (inline-)?fl(e)x
              case 101:
                return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
            }
            break;
          // writing-mode
          case 5936:
            switch (charat(value, length2 + 11)) {
              // vertical-l(r)
              case 114:
                return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
              // vertical-r(l)
              case 108:
                return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
              // horizontal(-)tb
              case 45:
                return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return WEBKIT + value + MS + value + value;
        }
        return value;
      }
      var prefixer = function prefixer2(element, index, children, callback) {
        if (element.length > -1) {
          if (!element["return"]) switch (element.type) {
            case DECLARATION:
              element["return"] = prefix(element.value, element.length);
              break;
            case KEYFRAMES:
              return serialize([copy(element, {
                value: replace(element.value, "@", "@" + WEBKIT)
              })], callback);
            case RULESET:
              if (element.length) return combine(element.props, function(value) {
                switch (match(value, /(::plac\w+|:read-\w+)/)) {
                  // :read-(only|write)
                  case ":read-only":
                  case ":read-write":
                    return serialize([copy(element, {
                      props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
                    })], callback);
                  // :placeholder
                  case "::placeholder":
                    return serialize([copy(element, {
                      props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                    }), copy(element, {
                      props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
                    }), copy(element, {
                      props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
                    })], callback);
                }
                return "";
              });
          }
        }
      };
      var defaultStylisPlugins = [prefixer];
      var createCache = function createCache2(options) {
        var key = options.key;
        if (key === "css") {
          var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
          Array.prototype.forEach.call(ssrStyles, function(node2) {
            var dataEmotionAttribute = node2.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) {
              return;
            }
            document.head.appendChild(node2);
            node2.setAttribute("data-s", "");
          });
        }
        var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
        var inserted = {};
        var container;
        var nodesToHydrate = [];
        {
          container = options.container || document.head;
          Array.prototype.forEach.call(
            // this means we will ignore elements which don't have a space in them which
            // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
            document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
            function(node2) {
              var attrib = node2.getAttribute("data-emotion").split(" ");
              for (var i = 1; i < attrib.length; i++) {
                inserted[attrib[i]] = true;
              }
              nodesToHydrate.push(node2);
            }
          );
        }
        var _insert;
        var omnipresentPlugins = [compat, removeLabel];
        {
          var currentSheet;
          var finalizingPlugins = [stringify, rulesheet(function(rule) {
            currentSheet.insert(rule);
          })];
          var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
          var stylis = function stylis2(styles) {
            return serialize(compile(styles), serializer);
          };
          _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) {
              cache.inserted[serialized.name] = true;
            }
          };
        }
        var cache = {
          key,
          sheet: new StyleSheet({
            key,
            container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
          }),
          nonce: options.nonce,
          inserted,
          registered: {},
          insert: _insert
        };
        cache.sheet.hydrate(nodesToHydrate);
        return cache;
      };
      var isBrowser = true;
      function getRegisteredStyles(registered, registeredStyles, classNames) {
        var rawClassName = "";
        classNames.split(" ").forEach(function(className) {
          if (registered[className] !== void 0) {
            registeredStyles.push(registered[className] + ";");
          } else if (className) {
            rawClassName += className + " ";
          }
        });
        return rawClassName;
      }
      var registerStyles = function registerStyles2(cache, serialized, isStringTag2) {
        var className = cache.key + "-" + serialized.name;
        if (
          // we only need to add the styles to the registered cache if the
          // class name could be used further down
          // the tree but if it's a string tag, we know it won't
          // so we don't have to add it to registered cache.
          // this improves memory usage since we can avoid storing the whole style string
          (isStringTag2 === false || // we need to always store it if we're in compat mode and
          // in node since emotion-server relies on whether a style is in
          // the registered cache to know whether a style is global or not
          // also, note that this check will be dead code eliminated in the browser
          isBrowser === false) && cache.registered[className] === void 0
        ) {
          cache.registered[className] = serialized.styles;
        }
      };
      var insertStyles = function insertStyles2(cache, serialized, isStringTag2) {
        registerStyles(cache, serialized, isStringTag2);
        var className = cache.key + "-" + serialized.name;
        if (cache.inserted[serialized.name] === void 0) {
          var current = serialized;
          do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
          } while (current !== void 0);
        }
      };
      function murmur2(str) {
        var h = 0;
        var k, i = 0, len = str.length;
        for (; len >= 4; ++i, len -= 4) {
          k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
          k = /* Math.imul(k, m): */
          (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
          k ^= /* k >>> r: */
          k >>> 24;
          h = /* Math.imul(k, m): */
          (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
          (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
        }
        switch (len) {
          case 3:
            h ^= (str.charCodeAt(i + 2) & 255) << 16;
          case 2:
            h ^= (str.charCodeAt(i + 1) & 255) << 8;
          case 1:
            h ^= str.charCodeAt(i) & 255;
            h = /* Math.imul(h, m): */
            (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
        }
        h ^= h >>> 13;
        h = /* Math.imul(h, m): */
        (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
        return ((h ^ h >>> 15) >>> 0).toString(36);
      }
      var unitlessKeys = {
        animationIterationCount: 1,
        aspectRatio: 1,
        borderImageOutset: 1,
        borderImageSlice: 1,
        borderImageWidth: 1,
        boxFlex: 1,
        boxFlexGroup: 1,
        boxOrdinalGroup: 1,
        columnCount: 1,
        columns: 1,
        flex: 1,
        flexGrow: 1,
        flexPositive: 1,
        flexShrink: 1,
        flexNegative: 1,
        flexOrder: 1,
        gridRow: 1,
        gridRowEnd: 1,
        gridRowSpan: 1,
        gridRowStart: 1,
        gridColumn: 1,
        gridColumnEnd: 1,
        gridColumnSpan: 1,
        gridColumnStart: 1,
        msGridRow: 1,
        msGridRowSpan: 1,
        msGridColumn: 1,
        msGridColumnSpan: 1,
        fontWeight: 1,
        lineHeight: 1,
        opacity: 1,
        order: 1,
        orphans: 1,
        scale: 1,
        tabSize: 1,
        widows: 1,
        zIndex: 1,
        zoom: 1,
        WebkitLineClamp: 1,
        // SVG-related properties
        fillOpacity: 1,
        floodOpacity: 1,
        stopOpacity: 1,
        strokeDasharray: 1,
        strokeDashoffset: 1,
        strokeMiterlimit: 1,
        strokeOpacity: 1,
        strokeWidth: 1
      };
      var hyphenateRegex = /[A-Z]|^ms/g;
      var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
      var isCustomProperty = function isCustomProperty2(property) {
        return property.charCodeAt(1) === 45;
      };
      var isProcessableValue = function isProcessableValue2(value) {
        return value != null && typeof value !== "boolean";
      };
      var processStyleName = /* @__PURE__ */ memoize$1(function(styleName) {
        return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
      });
      var processStyleValue = function processStyleValue2(key, value) {
        switch (key) {
          case "animation":
          case "animationName": {
            if (typeof value === "string") {
              return value.replace(animationRegex, function(match2, p1, p2) {
                cursor = {
                  name: p1,
                  styles: p2,
                  next: cursor
                };
                return p1;
              });
            }
          }
        }
        if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
          return value + "px";
        }
        return value;
      };
      function handleInterpolation(mergedProps, registered, interpolation) {
        if (interpolation == null) {
          return "";
        }
        var componentSelector = interpolation;
        if (componentSelector.__emotion_styles !== void 0) {
          return componentSelector;
        }
        switch (typeof interpolation) {
          case "boolean": {
            return "";
          }
          case "object": {
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
              cursor = {
                name: keyframes.name,
                styles: keyframes.styles,
                next: cursor
              };
              return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== void 0) {
              var next2 = serializedStyles.next;
              if (next2 !== void 0) {
                while (next2 !== void 0) {
                  cursor = {
                    name: next2.name,
                    styles: next2.styles,
                    next: cursor
                  };
                  next2 = next2.next;
                }
              }
              var styles = serializedStyles.styles + ";";
              return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
          }
          case "function": {
            if (mergedProps !== void 0) {
              var previousCursor = cursor;
              var result = interpolation(mergedProps);
              cursor = previousCursor;
              return handleInterpolation(mergedProps, registered, result);
            }
            break;
          }
        }
        var asString = interpolation;
        if (registered == null) {
          return asString;
        }
        var cached = registered[asString];
        return cached !== void 0 ? cached : asString;
      }
      function createStringFromObject(mergedProps, registered, obj) {
        var string = "";
        if (Array.isArray(obj)) {
          for (var i = 0; i < obj.length; i++) {
            string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
          }
        } else {
          for (var key in obj) {
            var value = obj[key];
            if (typeof value !== "object") {
              var asString = value;
              if (registered != null && registered[asString] !== void 0) {
                string += key + "{" + registered[asString] + "}";
              } else if (isProcessableValue(asString)) {
                string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
              }
            } else {
              if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
                for (var _i = 0; _i < value.length; _i++) {
                  if (isProcessableValue(value[_i])) {
                    string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
                  }
                }
              } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch (key) {
                  case "animation":
                  case "animationName": {
                    string += processStyleName(key) + ":" + interpolated + ";";
                    break;
                  }
                  default: {
                    string += key + "{" + interpolated + "}";
                  }
                }
              }
            }
          }
        }
        return string;
      }
      var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
      var cursor;
      function serializeStyles(args, registered, mergedProps) {
        if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
          return args[0];
        }
        var stringMode = true;
        var styles = "";
        cursor = void 0;
        var strings = args[0];
        if (strings == null || strings.raw === void 0) {
          stringMode = false;
          styles += handleInterpolation(mergedProps, registered, strings);
        } else {
          var asTemplateStringsArr = strings;
          styles += asTemplateStringsArr[0];
        }
        for (var i = 1; i < args.length; i++) {
          styles += handleInterpolation(mergedProps, registered, args[i]);
          if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
          }
        }
        labelPattern.lastIndex = 0;
        var identifierName = "";
        var match2;
        while ((match2 = labelPattern.exec(styles)) !== null) {
          identifierName += "-" + match2[1];
        }
        var name = murmur2(styles) + identifierName;
        return {
          name,
          styles,
          next: cursor
        };
      }
      var syncFallback = function syncFallback2(create) {
        return create();
      };
      var useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
      var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
      var EmotionCacheContext = /* @__PURE__ */ reactExports.createContext(
        // we're doing this to avoid preconstruct's dead code elimination in this one case
        // because this module is primarily intended for the browser and node
        // but it's also required in react native and similar environments sometimes
        // and we could have a special build just for that
        // but this is much easier and the native packages
        // might use a different theme context in the future anyway
        typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
          key: "css"
        }) : null
      );
      EmotionCacheContext.Provider;
      var withEmotionCache = function withEmotionCache2(func) {
        return /* @__PURE__ */ reactExports.forwardRef(function(props, ref) {
          var cache = reactExports.useContext(EmotionCacheContext);
          return func(props, cache, ref);
        });
      };
      var ThemeContext = exports("T", /* @__PURE__ */ reactExports.createContext({}));
      var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
      var isPropValid = /* @__PURE__ */ memoize$1(
        function(prop) {
          return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
        }
        /* Z+1 */
      );
      var testOmitPropsOnStringTag = isPropValid;
      var testOmitPropsOnComponent = function testOmitPropsOnComponent2(key) {
        return key !== "theme";
      };
      var getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag) {
        return typeof tag === "string" && // 96 is one less than the char code
        // for "a" so this is checking that
        // it's a lowercase character
        tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
      };
      var composeShouldForwardProps = function composeShouldForwardProps2(tag, options, isReal) {
        var shouldForwardProp2;
        if (options) {
          var optionsShouldForwardProp = options.shouldForwardProp;
          shouldForwardProp2 = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
          } : optionsShouldForwardProp;
        }
        if (typeof shouldForwardProp2 !== "function" && isReal) {
          shouldForwardProp2 = tag.__emotion_forwardProp;
        }
        return shouldForwardProp2;
      };
      var Insertion = function Insertion2(_ref) {
        var cache = _ref.cache, serialized = _ref.serialized, isStringTag2 = _ref.isStringTag;
        registerStyles(cache, serialized, isStringTag2);
        useInsertionEffectAlwaysWithSyncFallback(function() {
          return insertStyles(cache, serialized, isStringTag2);
        });
        return null;
      };
      var createStyled$1 = function createStyled2(tag, options) {
        var isReal = tag.__emotion_real === tag;
        var baseTag = isReal && tag.__emotion_base || tag;
        var identifierName;
        var targetClassName;
        if (options !== void 0) {
          identifierName = options.label;
          targetClassName = options.target;
        }
        var shouldForwardProp2 = composeShouldForwardProps(tag, options, isReal);
        var defaultShouldForwardProp = shouldForwardProp2 || getDefaultShouldForwardProp(baseTag);
        var shouldUseAs = !defaultShouldForwardProp("as");
        return function() {
          var args = arguments;
          var styles = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
          if (identifierName !== void 0) {
            styles.push("label:" + identifierName + ";");
          }
          if (args[0] == null || args[0].raw === void 0) {
            styles.push.apply(styles, args);
          } else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for (; i < len; i++) {
              styles.push(args[i], templateStringsArr[i]);
            }
          }
          var Styled = withEmotionCache(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
              mergedProps = {};
              for (var key in props) {
                mergedProps[key] = props[key];
              }
              mergedProps.theme = reactExports.useContext(ThemeContext);
            }
            if (typeof props.className === "string") {
              className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
            } else if (props.className != null) {
              className = props.className + " ";
            }
            var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== void 0) {
              className += " " + targetClassName;
            }
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp2 === void 0 ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for (var _key in props) {
              if (shouldUseAs && _key === "as") continue;
              if (finalShouldForwardProp(_key)) {
                newProps[_key] = props[_key];
              }
            }
            newProps.className = className;
            if (ref) {
              newProps.ref = ref;
            }
            return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(Insertion, {
              cache,
              serialized,
              isStringTag: typeof FinalTag === "string"
            }), /* @__PURE__ */ reactExports.createElement(FinalTag, newProps));
          });
          Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
          Styled.defaultProps = tag.defaultProps;
          Styled.__emotion_real = Styled;
          Styled.__emotion_base = baseTag;
          Styled.__emotion_styles = styles;
          Styled.__emotion_forwardProp = shouldForwardProp2;
          Object.defineProperty(Styled, "toString", {
            value: function value() {
              return "." + targetClassName;
            }
          });
          Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled2 = createStyled2(nextTag, _extends({}, options, nextOptions, {
              shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled2.apply(void 0, styles);
          };
          return Styled;
        };
      };
      var tags = [
        "a",
        "abbr",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "base",
        "bdi",
        "bdo",
        "big",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "cite",
        "code",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "dialog",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "keygen",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "meter",
        "nav",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "title",
        "tr",
        "track",
        "u",
        "ul",
        "var",
        "video",
        "wbr",
        // SVG
        "circle",
        "clipPath",
        "defs",
        "ellipse",
        "foreignObject",
        "g",
        "image",
        "line",
        "linearGradient",
        "mask",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialGradient",
        "rect",
        "stop",
        "svg",
        "text",
        "tspan"
      ];
      var newStyled = createStyled$1.bind(null);
      tags.forEach(function(tagName) {
        newStyled[tagName] = newStyled(tagName);
      });
      function styled$1(tag, options) {
        const stylesFactory = newStyled(tag, options);
        return stylesFactory;
      }
      function internal_mutateStyles(tag, processor) {
        if (Array.isArray(tag.__emotion_styles)) {
          tag.__emotion_styles = processor(tag.__emotion_styles);
        }
      }
      const wrapper = [];
      function internal_serializeStyles(styles) {
        wrapper[0] = styles;
        return serializeStyles(wrapper);
      }
      var reactIs = { exports: {} };
      var reactIs_production = {};
      /**
       * @license React
       * react-is.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var hasRequiredReactIs_production;
      function requireReactIs_production() {
        if (hasRequiredReactIs_production) return reactIs_production;
        hasRequiredReactIs_production = 1;
        var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
        var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
        function typeOf(object) {
          if ("object" === typeof object && null !== object) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                switch (object = object.type, object) {
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                  case REACT_SUSPENSE_LIST_TYPE:
                    return object;
                  default:
                    switch (object = object && object.$$typeof, object) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                        return object;
                      case REACT_CONSUMER_TYPE:
                        return object;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
        }
        reactIs_production.ContextConsumer = REACT_CONSUMER_TYPE;
        reactIs_production.ContextProvider = REACT_CONTEXT_TYPE;
        reactIs_production.Element = REACT_ELEMENT_TYPE;
        reactIs_production.ForwardRef = REACT_FORWARD_REF_TYPE;
        reactIs_production.Fragment = REACT_FRAGMENT_TYPE;
        reactIs_production.Lazy = REACT_LAZY_TYPE;
        reactIs_production.Memo = REACT_MEMO_TYPE;
        reactIs_production.Portal = REACT_PORTAL_TYPE;
        reactIs_production.Profiler = REACT_PROFILER_TYPE;
        reactIs_production.StrictMode = REACT_STRICT_MODE_TYPE;
        reactIs_production.Suspense = REACT_SUSPENSE_TYPE;
        reactIs_production.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
        reactIs_production.isContextConsumer = function(object) {
          return typeOf(object) === REACT_CONSUMER_TYPE;
        };
        reactIs_production.isContextProvider = function(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        };
        reactIs_production.isElement = function(object) {
          return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
        };
        reactIs_production.isForwardRef = function(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        };
        reactIs_production.isFragment = function(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        };
        reactIs_production.isLazy = function(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        };
        reactIs_production.isMemo = function(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        };
        reactIs_production.isPortal = function(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        };
        reactIs_production.isProfiler = function(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        };
        reactIs_production.isStrictMode = function(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        };
        reactIs_production.isSuspense = function(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        };
        reactIs_production.isSuspenseList = function(object) {
          return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
        };
        reactIs_production.isValidElementType = function(type) {
          return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
        };
        reactIs_production.typeOf = typeOf;
        return reactIs_production;
      }
      var hasRequiredReactIs;
      function requireReactIs() {
        if (hasRequiredReactIs) return reactIs.exports;
        hasRequiredReactIs = 1;
        {
          reactIs.exports = /* @__PURE__ */ requireReactIs_production();
        }
        return reactIs.exports;
      }
      var reactIsExports = /* @__PURE__ */ requireReactIs();
      function isPlainObject(item) {
        if (typeof item !== "object" || item === null) {
          return false;
        }
        const prototype = Object.getPrototypeOf(item);
        return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
      }
      function deepClone(source) {
        if (/* @__PURE__ */ reactExports.isValidElement(source) || reactIsExports.isValidElementType(source) || !isPlainObject(source)) {
          return source;
        }
        const output = {};
        Object.keys(source).forEach((key) => {
          output[key] = deepClone(source[key]);
        });
        return output;
      }
      function deepmerge(target, source, options = {
        clone: true
      }) {
        const output = options.clone ? {
          ...target
        } : target;
        if (isPlainObject(target) && isPlainObject(source)) {
          Object.keys(source).forEach((key) => {
            if (/* @__PURE__ */ reactExports.isValidElement(source[key]) || reactIsExports.isValidElementType(source[key])) {
              output[key] = source[key];
            } else if (isPlainObject(source[key]) && // Avoid prototype pollution
            Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
              output[key] = deepmerge(target[key], source[key], options);
            } else if (options.clone) {
              output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
            } else {
              output[key] = source[key];
            }
          });
        }
        return output;
      }
      const sortBreakpointsValues = (values2) => {
        const breakpointsAsArray = Object.keys(values2).map((key) => ({
          key,
          val: values2[key]
        })) || [];
        breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
        return breakpointsAsArray.reduce((acc, obj) => {
          return {
            ...acc,
            [obj.key]: obj.val
          };
        }, {});
      };
      function createBreakpoints(breakpoints) {
        const {
          // The breakpoint **start** at this value.
          // For instance with the first breakpoint xs: [xs, sm).
          values: values2 = {
            xs: 0,
            // phone
            sm: 600,
            // tablet
            md: 900,
            // small laptop
            lg: 1200,
            // desktop
            xl: 1536
            // large screen
          },
          unit = "px",
          step = 5,
          ...other
        } = breakpoints;
        const sortedValues = sortBreakpointsValues(values2);
        const keys = Object.keys(sortedValues);
        function up(key) {
          const value = typeof values2[key] === "number" ? values2[key] : key;
          return `@media (min-width:${value}${unit})`;
        }
        function down(key) {
          const value = typeof values2[key] === "number" ? values2[key] : key;
          return `@media (max-width:${value - step / 100}${unit})`;
        }
        function between(start, end) {
          const endIndex = keys.indexOf(end);
          return `@media (min-width:${typeof values2[start] === "number" ? values2[start] : start}${unit}) and (max-width:${(endIndex !== -1 && typeof values2[keys[endIndex]] === "number" ? values2[keys[endIndex]] : end) - step / 100}${unit})`;
        }
        function only(key) {
          if (keys.indexOf(key) + 1 < keys.length) {
            return between(key, keys[keys.indexOf(key) + 1]);
          }
          return up(key);
        }
        function not(key) {
          const keyIndex = keys.indexOf(key);
          if (keyIndex === 0) {
            return up(keys[1]);
          }
          if (keyIndex === keys.length - 1) {
            return down(keys[keyIndex]);
          }
          return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
        }
        return {
          keys,
          values: sortedValues,
          up,
          down,
          between,
          only,
          not,
          unit,
          ...other
        };
      }
      function sortContainerQueries(theme, css) {
        if (!theme.containerQueries) {
          return css;
        }
        const sorted = Object.keys(css).filter((key) => key.startsWith("@container")).sort((a, b) => {
          var _a, _b;
          const regex = /min-width:\s*([0-9.]+)/;
          return +(((_a = a.match(regex)) == null ? void 0 : _a[1]) || 0) - +(((_b = b.match(regex)) == null ? void 0 : _b[1]) || 0);
        });
        if (!sorted.length) {
          return css;
        }
        return sorted.reduce((acc, key) => {
          const value = css[key];
          delete acc[key];
          acc[key] = value;
          return acc;
        }, {
          ...css
        });
      }
      function isCqShorthand(breakpointKeys, value) {
        return value === "@" || value.startsWith("@") && (breakpointKeys.some((key) => value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
      }
      function getContainerQuery(theme, shorthand) {
        const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
        if (!matches) {
          return null;
        }
        const [, containerQuery, containerName] = matches;
        const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
        return theme.containerQueries(containerName).up(value);
      }
      function cssContainerQueries(themeInput) {
        const toContainerQuery = (mediaQuery, name) => mediaQuery.replace("@media", name ? `@container ${name}` : "@container");
        function attachCq(node22, name) {
          node22.up = (...args) => toContainerQuery(themeInput.breakpoints.up(...args), name);
          node22.down = (...args) => toContainerQuery(themeInput.breakpoints.down(...args), name);
          node22.between = (...args) => toContainerQuery(themeInput.breakpoints.between(...args), name);
          node22.only = (...args) => toContainerQuery(themeInput.breakpoints.only(...args), name);
          node22.not = (...args) => {
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes("not all and")) {
              return result.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or");
            }
            return result;
          };
        }
        const node2 = {};
        const containerQueries = (name) => {
          attachCq(node2, name);
          return node2;
        };
        attachCq(containerQueries);
        return {
          ...themeInput,
          containerQueries
        };
      }
      const shape = {
        borderRadius: 4
      };
      function merge(acc, item) {
        if (!item) {
          return acc;
        }
        return deepmerge(acc, item, {
          clone: false
          // No need to clone deep, it's way faster.
        });
      }
      const values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536
        // large screen
      };
      const defaultBreakpoints = {
        // Sorted ASC by size. That's important.
        // It can't be configured as it's used statically for propTypes.
        keys: ["xs", "sm", "md", "lg", "xl"],
        up: (key) => `@media (min-width:${values[key]}px)`
      };
      const defaultContainerQueries = {
        containerQueries: (containerName) => ({
          up: (key) => {
            let result = typeof key === "number" ? key : values[key] || key;
            if (typeof result === "number") {
              result = `${result}px`;
            }
            return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
          }
        })
      };
      function handleBreakpoints(props, propValue, styleFromPropValue) {
        const theme = props.theme || {};
        if (Array.isArray(propValue)) {
          const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
          return propValue.reduce((acc, item, index) => {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
          }, {});
        }
        if (typeof propValue === "object") {
          const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
          return Object.keys(propValue).reduce((acc, breakpoint) => {
            if (isCqShorthand(themeBreakpoints.keys, breakpoint)) {
              const containerKey = getContainerQuery(theme.containerQueries ? theme : defaultContainerQueries, breakpoint);
              if (containerKey) {
                acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
              }
            } else if (Object.keys(themeBreakpoints.values || values).includes(breakpoint)) {
              const mediaKey = themeBreakpoints.up(breakpoint);
              acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
              const cssKey = breakpoint;
              acc[cssKey] = propValue[cssKey];
            }
            return acc;
          }, {});
        }
        const output = styleFromPropValue(propValue);
        return output;
      }
      function createEmptyBreakpointObject(breakpointsInput = {}) {
        var _a;
        const breakpointsInOrder = (_a = breakpointsInput.keys) == null ? void 0 : _a.reduce((acc, key) => {
          const breakpointStyleKey = breakpointsInput.up(key);
          acc[breakpointStyleKey] = {};
          return acc;
        }, {});
        return breakpointsInOrder || {};
      }
      function removeUnusedBreakpoints(breakpointKeys, style2) {
        return breakpointKeys.reduce((acc, key) => {
          const breakpointOutput = acc[key];
          const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
          if (isBreakpointUnused) {
            delete acc[key];
          }
          return acc;
        }, style2);
      }
      function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
        if (typeof breakpointValues !== "object") {
          return {};
        }
        const base = {};
        const breakpointsKeys = Object.keys(themeBreakpoints);
        if (Array.isArray(breakpointValues)) {
          breakpointsKeys.forEach((breakpoint, i) => {
            if (i < breakpointValues.length) {
              base[breakpoint] = true;
            }
          });
        } else {
          breakpointsKeys.forEach((breakpoint) => {
            if (breakpointValues[breakpoint] != null) {
              base[breakpoint] = true;
            }
          });
        }
        return base;
      }
      function resolveBreakpointValues({
        values: breakpointValues,
        breakpoints: themeBreakpoints,
        base: customBase
      }) {
        const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
        const keys = Object.keys(base);
        if (keys.length === 0) {
          return breakpointValues;
        }
        let previous;
        return keys.reduce((acc, breakpoint, i) => {
          if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
          } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
          } else {
            acc[breakpoint] = breakpointValues;
          }
          return acc;
        }, {});
      }
      function capitalize(string) {
        if (typeof string !== "string") {
          throw new Error(formatMuiErrorMessage(7));
        }
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
      function getPath(obj, path, checkVars = true) {
        if (!path || typeof path !== "string") {
          return null;
        }
        if (obj && obj.vars && checkVars) {
          const val = `vars.${path}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
          if (val != null) {
            return val;
          }
        }
        return path.split(".").reduce((acc, item) => {
          if (acc && acc[item] != null) {
            return acc[item];
          }
          return null;
        }, obj);
      }
      function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
        let value;
        if (typeof themeMapping === "function") {
          value = themeMapping(propValueFinal);
        } else if (Array.isArray(themeMapping)) {
          value = themeMapping[propValueFinal] || userValue;
        } else {
          value = getPath(themeMapping, propValueFinal) || userValue;
        }
        if (transform) {
          value = transform(value, userValue, themeMapping);
        }
        return value;
      }
      function style$1(options) {
        const {
          prop,
          cssProperty = options.prop,
          themeKey,
          transform
        } = options;
        const fn = (props) => {
          if (props[prop] == null) {
            return null;
          }
          const propValue = props[prop];
          const theme = props.theme;
          const themeMapping = getPath(theme, themeKey) || {};
          const styleFromPropValue = (propValueFinal) => {
            let value = getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") {
              value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
            }
            if (cssProperty === false) {
              return value;
            }
            return {
              [cssProperty]: value
            };
          };
          return handleBreakpoints(props, propValue, styleFromPropValue);
        };
        fn.propTypes = {};
        fn.filterProps = [prop];
        return fn;
      }
      function memoize(fn) {
        const cache = {};
        return (arg2) => {
          if (cache[arg2] === void 0) {
            cache[arg2] = fn(arg2);
          }
          return cache[arg2];
        };
      }
      const properties = {
        m: "margin",
        p: "padding"
      };
      const directions = {
        t: "Top",
        r: "Right",
        b: "Bottom",
        l: "Left",
        x: ["Left", "Right"],
        y: ["Top", "Bottom"]
      };
      const aliases = {
        marginX: "mx",
        marginY: "my",
        paddingX: "px",
        paddingY: "py"
      };
      const getCssProperties = memoize((prop) => {
        if (prop.length > 2) {
          if (aliases[prop]) {
            prop = aliases[prop];
          } else {
            return [prop];
          }
        }
        const [a, b] = prop.split("");
        const property = properties[a];
        const direction = directions[b] || "";
        return Array.isArray(direction) ? direction.map((dir) => property + dir) : [property + direction];
      });
      const marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"];
      const paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
      [...marginKeys, ...paddingKeys];
      function createUnaryUnit(theme, themeKey, defaultValue, propName) {
        const themeSpacing = getPath(theme, themeKey, true) ?? defaultValue;
        if (typeof themeSpacing === "number" || typeof themeSpacing === "string") {
          return (val) => {
            if (typeof val === "string") {
              return val;
            }
            if (typeof themeSpacing === "string") {
              return `calc(${val} * ${themeSpacing})`;
            }
            return themeSpacing * val;
          };
        }
        if (Array.isArray(themeSpacing)) {
          return (val) => {
            if (typeof val === "string") {
              return val;
            }
            const abs2 = Math.abs(val);
            const transformed = themeSpacing[abs2];
            if (val >= 0) {
              return transformed;
            }
            if (typeof transformed === "number") {
              return -transformed;
            }
            return `-${transformed}`;
          };
        }
        if (typeof themeSpacing === "function") {
          return themeSpacing;
        }
        return () => void 0;
      }
      function createUnarySpacing(theme) {
        return createUnaryUnit(theme, "spacing", 8);
      }
      function getValue(transformer, propValue) {
        if (typeof propValue === "string" || propValue == null) {
          return propValue;
        }
        return transformer(propValue);
      }
      function getStyleFromPropValue(cssProperties, transformer) {
        return (propValue) => cssProperties.reduce((acc, cssProperty) => {
          acc[cssProperty] = getValue(transformer, propValue);
          return acc;
        }, {});
      }
      function resolveCssProperty(props, keys, prop, transformer) {
        if (!keys.includes(prop)) {
          return null;
        }
        const cssProperties = getCssProperties(prop);
        const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
        const propValue = props[prop];
        return handleBreakpoints(props, propValue, styleFromPropValue);
      }
      function style(props, keys) {
        const transformer = createUnarySpacing(props.theme);
        return Object.keys(props).map((prop) => resolveCssProperty(props, keys, prop, transformer)).reduce(merge, {});
      }
      function margin(props) {
        return style(props, marginKeys);
      }
      margin.propTypes = {};
      margin.filterProps = marginKeys;
      function padding(props) {
        return style(props, paddingKeys);
      }
      padding.propTypes = {};
      padding.filterProps = paddingKeys;
      function createSpacing(spacingInput = 8, transform = createUnarySpacing({
        spacing: spacingInput
      })) {
        if (spacingInput.mui) {
          return spacingInput;
        }
        const spacing = (...argsInput) => {
          const args = argsInput.length === 0 ? [1] : argsInput;
          return args.map((argument) => {
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
          }).join(" ");
        };
        spacing.mui = true;
        return spacing;
      }
      function compose(...styles) {
        const handlers = styles.reduce((acc, style2) => {
          style2.filterProps.forEach((prop) => {
            acc[prop] = style2;
          });
          return acc;
        }, {});
        const fn = (props) => {
          return Object.keys(props).reduce((acc, prop) => {
            if (handlers[prop]) {
              return merge(acc, handlers[prop](props));
            }
            return acc;
          }, {});
        };
        fn.propTypes = {};
        fn.filterProps = styles.reduce((acc, style2) => acc.concat(style2.filterProps), []);
        return fn;
      }
      function borderTransform(value) {
        if (typeof value !== "number") {
          return value;
        }
        return `${value}px solid`;
      }
      function createBorderStyle(prop, transform) {
        return style$1({
          prop,
          themeKey: "borders",
          transform
        });
      }
      const border = createBorderStyle("border", borderTransform);
      const borderTop = createBorderStyle("borderTop", borderTransform);
      const borderRight = createBorderStyle("borderRight", borderTransform);
      const borderBottom = createBorderStyle("borderBottom", borderTransform);
      const borderLeft = createBorderStyle("borderLeft", borderTransform);
      const borderColor = createBorderStyle("borderColor");
      const borderTopColor = createBorderStyle("borderTopColor");
      const borderRightColor = createBorderStyle("borderRightColor");
      const borderBottomColor = createBorderStyle("borderBottomColor");
      const borderLeftColor = createBorderStyle("borderLeftColor");
      const outline = createBorderStyle("outline", borderTransform);
      const outlineColor = createBorderStyle("outlineColor");
      const borderRadius = (props) => {
        if (props.borderRadius !== void 0 && props.borderRadius !== null) {
          const transformer = createUnaryUnit(props.theme, "shape.borderRadius", 4);
          const styleFromPropValue = (propValue) => ({
            borderRadius: getValue(transformer, propValue)
          });
          return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
        }
        return null;
      };
      borderRadius.propTypes = {};
      borderRadius.filterProps = ["borderRadius"];
      compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
      const gap = (props) => {
        if (props.gap !== void 0 && props.gap !== null) {
          const transformer = createUnaryUnit(props.theme, "spacing", 8);
          const styleFromPropValue = (propValue) => ({
            gap: getValue(transformer, propValue)
          });
          return handleBreakpoints(props, props.gap, styleFromPropValue);
        }
        return null;
      };
      gap.propTypes = {};
      gap.filterProps = ["gap"];
      const columnGap = (props) => {
        if (props.columnGap !== void 0 && props.columnGap !== null) {
          const transformer = createUnaryUnit(props.theme, "spacing", 8);
          const styleFromPropValue = (propValue) => ({
            columnGap: getValue(transformer, propValue)
          });
          return handleBreakpoints(props, props.columnGap, styleFromPropValue);
        }
        return null;
      };
      columnGap.propTypes = {};
      columnGap.filterProps = ["columnGap"];
      const rowGap = (props) => {
        if (props.rowGap !== void 0 && props.rowGap !== null) {
          const transformer = createUnaryUnit(props.theme, "spacing", 8);
          const styleFromPropValue = (propValue) => ({
            rowGap: getValue(transformer, propValue)
          });
          return handleBreakpoints(props, props.rowGap, styleFromPropValue);
        }
        return null;
      };
      rowGap.propTypes = {};
      rowGap.filterProps = ["rowGap"];
      const gridColumn = style$1({
        prop: "gridColumn"
      });
      const gridRow = style$1({
        prop: "gridRow"
      });
      const gridAutoFlow = style$1({
        prop: "gridAutoFlow"
      });
      const gridAutoColumns = style$1({
        prop: "gridAutoColumns"
      });
      const gridAutoRows = style$1({
        prop: "gridAutoRows"
      });
      const gridTemplateColumns = style$1({
        prop: "gridTemplateColumns"
      });
      const gridTemplateRows = style$1({
        prop: "gridTemplateRows"
      });
      const gridTemplateAreas = style$1({
        prop: "gridTemplateAreas"
      });
      const gridArea = style$1({
        prop: "gridArea"
      });
      compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
      function paletteTransform(value, userValue) {
        if (userValue === "grey") {
          return userValue;
        }
        return value;
      }
      const color = style$1({
        prop: "color",
        themeKey: "palette",
        transform: paletteTransform
      });
      const bgcolor = style$1({
        prop: "bgcolor",
        cssProperty: "backgroundColor",
        themeKey: "palette",
        transform: paletteTransform
      });
      const backgroundColor = style$1({
        prop: "backgroundColor",
        themeKey: "palette",
        transform: paletteTransform
      });
      compose(color, bgcolor, backgroundColor);
      function sizingTransform(value) {
        return value <= 1 && value !== 0 ? `${value * 100}%` : value;
      }
      const width = style$1({
        prop: "width",
        transform: sizingTransform
      });
      const maxWidth = (props) => {
        if (props.maxWidth !== void 0 && props.maxWidth !== null) {
          const styleFromPropValue = (propValue) => {
            var _a, _b, _c, _d, _e;
            const breakpoint = ((_c = (_b = (_a = props.theme) == null ? void 0 : _a.breakpoints) == null ? void 0 : _b.values) == null ? void 0 : _c[propValue]) || values[propValue];
            if (!breakpoint) {
              return {
                maxWidth: sizingTransform(propValue)
              };
            }
            if (((_e = (_d = props.theme) == null ? void 0 : _d.breakpoints) == null ? void 0 : _e.unit) !== "px") {
              return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
              };
            }
            return {
              maxWidth: breakpoint
            };
          };
          return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
        }
        return null;
      };
      maxWidth.filterProps = ["maxWidth"];
      const minWidth = style$1({
        prop: "minWidth",
        transform: sizingTransform
      });
      const height = style$1({
        prop: "height",
        transform: sizingTransform
      });
      const maxHeight = style$1({
        prop: "maxHeight",
        transform: sizingTransform
      });
      const minHeight = style$1({
        prop: "minHeight",
        transform: sizingTransform
      });
      style$1({
        prop: "size",
        cssProperty: "width",
        transform: sizingTransform
      });
      style$1({
        prop: "size",
        cssProperty: "height",
        transform: sizingTransform
      });
      const boxSizing = style$1({
        prop: "boxSizing"
      });
      compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
      const defaultSxConfig = {
        // borders
        border: {
          themeKey: "borders",
          transform: borderTransform
        },
        borderTop: {
          themeKey: "borders",
          transform: borderTransform
        },
        borderRight: {
          themeKey: "borders",
          transform: borderTransform
        },
        borderBottom: {
          themeKey: "borders",
          transform: borderTransform
        },
        borderLeft: {
          themeKey: "borders",
          transform: borderTransform
        },
        borderColor: {
          themeKey: "palette"
        },
        borderTopColor: {
          themeKey: "palette"
        },
        borderRightColor: {
          themeKey: "palette"
        },
        borderBottomColor: {
          themeKey: "palette"
        },
        borderLeftColor: {
          themeKey: "palette"
        },
        outline: {
          themeKey: "borders",
          transform: borderTransform
        },
        outlineColor: {
          themeKey: "palette"
        },
        borderRadius: {
          themeKey: "shape.borderRadius",
          style: borderRadius
        },
        // palette
        color: {
          themeKey: "palette",
          transform: paletteTransform
        },
        bgcolor: {
          themeKey: "palette",
          cssProperty: "backgroundColor",
          transform: paletteTransform
        },
        backgroundColor: {
          themeKey: "palette",
          transform: paletteTransform
        },
        // spacing
        p: {
          style: padding
        },
        pt: {
          style: padding
        },
        pr: {
          style: padding
        },
        pb: {
          style: padding
        },
        pl: {
          style: padding
        },
        px: {
          style: padding
        },
        py: {
          style: padding
        },
        padding: {
          style: padding
        },
        paddingTop: {
          style: padding
        },
        paddingRight: {
          style: padding
        },
        paddingBottom: {
          style: padding
        },
        paddingLeft: {
          style: padding
        },
        paddingX: {
          style: padding
        },
        paddingY: {
          style: padding
        },
        paddingInline: {
          style: padding
        },
        paddingInlineStart: {
          style: padding
        },
        paddingInlineEnd: {
          style: padding
        },
        paddingBlock: {
          style: padding
        },
        paddingBlockStart: {
          style: padding
        },
        paddingBlockEnd: {
          style: padding
        },
        m: {
          style: margin
        },
        mt: {
          style: margin
        },
        mr: {
          style: margin
        },
        mb: {
          style: margin
        },
        ml: {
          style: margin
        },
        mx: {
          style: margin
        },
        my: {
          style: margin
        },
        margin: {
          style: margin
        },
        marginTop: {
          style: margin
        },
        marginRight: {
          style: margin
        },
        marginBottom: {
          style: margin
        },
        marginLeft: {
          style: margin
        },
        marginX: {
          style: margin
        },
        marginY: {
          style: margin
        },
        marginInline: {
          style: margin
        },
        marginInlineStart: {
          style: margin
        },
        marginInlineEnd: {
          style: margin
        },
        marginBlock: {
          style: margin
        },
        marginBlockStart: {
          style: margin
        },
        marginBlockEnd: {
          style: margin
        },
        // display
        displayPrint: {
          cssProperty: false,
          transform: (value) => ({
            "@media print": {
              display: value
            }
          })
        },
        display: {},
        overflow: {},
        textOverflow: {},
        visibility: {},
        whiteSpace: {},
        // flexbox
        flexBasis: {},
        flexDirection: {},
        flexWrap: {},
        justifyContent: {},
        alignItems: {},
        alignContent: {},
        order: {},
        flex: {},
        flexGrow: {},
        flexShrink: {},
        alignSelf: {},
        justifyItems: {},
        justifySelf: {},
        // grid
        gap: {
          style: gap
        },
        rowGap: {
          style: rowGap
        },
        columnGap: {
          style: columnGap
        },
        gridColumn: {},
        gridRow: {},
        gridAutoFlow: {},
        gridAutoColumns: {},
        gridAutoRows: {},
        gridTemplateColumns: {},
        gridTemplateRows: {},
        gridTemplateAreas: {},
        gridArea: {},
        // positions
        position: {},
        zIndex: {
          themeKey: "zIndex"
        },
        top: {},
        right: {},
        bottom: {},
        left: {},
        // shadows
        boxShadow: {
          themeKey: "shadows"
        },
        // sizing
        width: {
          transform: sizingTransform
        },
        maxWidth: {
          style: maxWidth
        },
        minWidth: {
          transform: sizingTransform
        },
        height: {
          transform: sizingTransform
        },
        maxHeight: {
          transform: sizingTransform
        },
        minHeight: {
          transform: sizingTransform
        },
        boxSizing: {},
        // typography
        font: {
          themeKey: "font"
        },
        fontFamily: {
          themeKey: "typography"
        },
        fontSize: {
          themeKey: "typography"
        },
        fontStyle: {
          themeKey: "typography"
        },
        fontWeight: {
          themeKey: "typography"
        },
        letterSpacing: {},
        textTransform: {},
        lineHeight: {},
        textAlign: {},
        typography: {
          cssProperty: false,
          themeKey: "typography"
        }
      };
      function objectsHaveSameKeys(...objects) {
        const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
        const union = new Set(allKeys);
        return objects.every((object) => union.size === Object.keys(object).length);
      }
      function callIfFn(maybeFn, arg2) {
        return typeof maybeFn === "function" ? maybeFn(arg2) : maybeFn;
      }
      function unstable_createStyleFunctionSx() {
        function getThemeValue(prop, val, theme, config) {
          const props = {
            [prop]: val,
            theme
          };
          const options = config[prop];
          if (!options) {
            return {
              [prop]: val
            };
          }
          const {
            cssProperty = prop,
            themeKey,
            transform,
            style: style2
          } = options;
          if (val == null) {
            return null;
          }
          if (themeKey === "typography" && val === "inherit") {
            return {
              [prop]: val
            };
          }
          const themeMapping = getPath(theme, themeKey) || {};
          if (style2) {
            return style2(props);
          }
          const styleFromPropValue = (propValueFinal) => {
            let value = getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") {
              value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
            }
            if (cssProperty === false) {
              return value;
            }
            return {
              [cssProperty]: value
            };
          };
          return handleBreakpoints(props, val, styleFromPropValue);
        }
        function styleFunctionSx2(props) {
          const {
            sx,
            theme = {}
          } = props || {};
          if (!sx) {
            return null;
          }
          const config = theme.unstable_sxConfig ?? defaultSxConfig;
          function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") {
              sxObject = sxInput(theme);
            } else if (typeof sxInput !== "object") {
              return sxInput;
            }
            if (!sxObject) {
              return null;
            }
            const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey) => {
              const value = callIfFn(sxObject[styleKey], theme);
              if (value !== null && value !== void 0) {
                if (typeof value === "object") {
                  if (config[styleKey]) {
                    css = merge(css, getThemeValue(styleKey, value, theme, config));
                  } else {
                    const breakpointsValues = handleBreakpoints({
                      theme
                    }, value, (x) => ({
                      [styleKey]: x
                    }));
                    if (objectsHaveSameKeys(breakpointsValues, value)) {
                      css[styleKey] = styleFunctionSx2({
                        sx: value,
                        theme
                      });
                    } else {
                      css = merge(css, breakpointsValues);
                    }
                  }
                } else {
                  css = merge(css, getThemeValue(styleKey, value, theme, config));
                }
              }
            });
            return sortContainerQueries(theme, removeUnusedBreakpoints(breakpointsKeys, css));
          }
          return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
        }
        return styleFunctionSx2;
      }
      const styleFunctionSx = unstable_createStyleFunctionSx();
      styleFunctionSx.filterProps = ["sx"];
      function applyStyles(key, styles) {
        var _a;
        const theme = this;
        if (theme.vars) {
          if (!((_a = theme.colorSchemes) == null ? void 0 : _a[key]) || typeof theme.getColorSchemeSelector !== "function") {
            return {};
          }
          let selector = theme.getColorSchemeSelector(key);
          if (selector === "&") {
            return styles;
          }
          if (selector.includes("data-") || selector.includes(".")) {
            selector = `*:where(${selector.replace(/\s*&$/, "")}) &`;
          }
          return {
            [selector]: styles
          };
        }
        if (theme.palette.mode === key) {
          return styles;
        }
        return {};
      }
      function createTheme$1(options = {}, ...args) {
        const {
          breakpoints: breakpointsInput = {},
          palette: paletteInput = {},
          spacing: spacingInput,
          shape: shapeInput = {},
          ...other
        } = options;
        const breakpoints = createBreakpoints(breakpointsInput);
        const spacing = createSpacing(spacingInput);
        let muiTheme = deepmerge({
          breakpoints,
          direction: "ltr",
          components: {},
          // Inject component definitions.
          palette: {
            mode: "light",
            ...paletteInput
          },
          spacing,
          shape: {
            ...shape,
            ...shapeInput
          }
        }, other);
        muiTheme = cssContainerQueries(muiTheme);
        muiTheme.applyStyles = applyStyles;
        muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
        muiTheme.unstable_sxConfig = {
          ...defaultSxConfig,
          ...other == null ? void 0 : other.unstable_sxConfig
        };
        muiTheme.unstable_sx = function sx(props) {
          return styleFunctionSx({
            sx: props,
            theme: this
          });
        };
        return muiTheme;
      }
      const defaultGenerator = (componentName) => componentName;
      const createClassNameGenerator = () => {
        let generate = defaultGenerator;
        return {
          configure(generator) {
            generate = generator;
          },
          generate(componentName) {
            return generate(componentName);
          },
          reset() {
            generate = defaultGenerator;
          }
        };
      };
      const ClassNameGenerator = createClassNameGenerator();
      const globalStateClasses = {
        active: "active",
        checked: "checked",
        completed: "completed",
        disabled: "disabled",
        error: "error",
        expanded: "expanded",
        focused: "focused",
        focusVisible: "focusVisible",
        open: "open",
        readOnly: "readOnly",
        required: "required",
        selected: "selected"
      };
      function generateUtilityClass(componentName, slot, globalStatePrefix = "Mui") {
        const globalStateClass = globalStateClasses[slot];
        return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator.generate(componentName)}-${slot}`;
      }
      function generateUtilityClasses(componentName, slots, globalStatePrefix = "Mui") {
        const result = {};
        slots.forEach((slot) => {
          result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
        });
        return result;
      }
      function preprocessStyles(input) {
        const {
          variants,
          ...style2
        } = input;
        const result = {
          variants,
          style: internal_serializeStyles(style2),
          isProcessed: true
        };
        if (result.style === style2) {
          return result;
        }
        if (variants) {
          variants.forEach((variant) => {
            if (typeof variant.style !== "function") {
              variant.style = internal_serializeStyles(variant.style);
            }
          });
        }
        return result;
      }
      const systemDefaultTheme = createTheme$1();
      function shouldForwardProp(prop) {
        return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
      }
      function defaultOverridesResolver(slot) {
        if (!slot) {
          return null;
        }
        return (_props, styles) => styles[slot];
      }
      function attachTheme(props, themeId, defaultTheme2) {
        props.theme = isObjectEmpty(props.theme) ? defaultTheme2 : props.theme[themeId] || props.theme;
      }
      function processStyle(props, style2) {
        const resolvedStyle = typeof style2 === "function" ? style2(props) : style2;
        if (Array.isArray(resolvedStyle)) {
          return resolvedStyle.flatMap((subStyle) => processStyle(props, subStyle));
        }
        if (Array.isArray(resolvedStyle == null ? void 0 : resolvedStyle.variants)) {
          let rootStyle;
          if (resolvedStyle.isProcessed) {
            rootStyle = resolvedStyle.style;
          } else {
            const {
              variants,
              ...otherStyles
            } = resolvedStyle;
            rootStyle = otherStyles;
          }
          return processStyleVariants(props, resolvedStyle.variants, [rootStyle]);
        }
        if (resolvedStyle == null ? void 0 : resolvedStyle.isProcessed) {
          return resolvedStyle.style;
        }
        return resolvedStyle;
      }
      function processStyleVariants(props, variants, results = []) {
        var _a;
        let mergedState;
        variantLoop: for (let i = 0; i < variants.length; i += 1) {
          const variant = variants[i];
          if (typeof variant.props === "function") {
            mergedState ?? (mergedState = {
              ...props,
              ...props.ownerState,
              ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) {
              continue;
            }
          } else {
            for (const key in variant.props) {
              if (props[key] !== variant.props[key] && ((_a = props.ownerState) == null ? void 0 : _a[key]) !== variant.props[key]) {
                continue variantLoop;
              }
            }
          }
          if (typeof variant.style === "function") {
            mergedState ?? (mergedState = {
              ...props,
              ...props.ownerState,
              ownerState: props.ownerState
            });
            results.push(variant.style(mergedState));
          } else {
            results.push(variant.style);
          }
        }
        return results;
      }
      function createStyled(input = {}) {
        const {
          themeId,
          defaultTheme: defaultTheme2 = systemDefaultTheme,
          rootShouldForwardProp: rootShouldForwardProp2 = shouldForwardProp,
          slotShouldForwardProp: slotShouldForwardProp2 = shouldForwardProp
        } = input;
        function styleAttachTheme(props) {
          attachTheme(props, themeId, defaultTheme2);
        }
        const styled2 = (tag, inputOptions = {}) => {
          internal_mutateStyles(tag, (styles) => styles.filter((style2) => style2 !== styleFunctionSx));
          const {
            name: componentName,
            slot: componentSlot,
            skipVariantsResolver: inputSkipVariantsResolver,
            skipSx: inputSkipSx,
            // TODO v6: remove `lowercaseFirstLetter()` in the next major release
            // For more details: https://github.com/mui/material-ui/pull/37908
            overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)),
            ...options
          } = inputOptions;
          const skipVariantsResolver = inputSkipVariantsResolver !== void 0 ? inputSkipVariantsResolver : (
            // TODO v6: remove `Root` in the next major release
            // For more details: https://github.com/mui/material-ui/pull/37908
            componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false
          );
          const skipSx = inputSkipSx || false;
          let shouldForwardPropOption = shouldForwardProp;
          if (componentSlot === "Root" || componentSlot === "root") {
            shouldForwardPropOption = rootShouldForwardProp2;
          } else if (componentSlot) {
            shouldForwardPropOption = slotShouldForwardProp2;
          } else if (isStringTag(tag)) {
            shouldForwardPropOption = void 0;
          }
          const defaultStyledResolver = styled$1(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: generateStyledLabel(),
            ...options
          });
          const transformStyle = (style2) => {
            if (typeof style2 === "function" && style2.__emotion_real !== style2) {
              return function styleFunctionProcessor(props) {
                return processStyle(props, style2);
              };
            }
            if (isPlainObject(style2)) {
              const serialized = preprocessStyles(style2);
              if (!serialized.variants) {
                return serialized.style;
              }
              return function styleObjectProcessor(props) {
                return processStyle(props, serialized);
              };
            }
            return style2;
          };
          const muiStyledResolver = (...expressionsInput) => {
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) {
              expressionsTail.push(function styleThemeOverrides(props) {
                var _a, _b;
                const theme = props.theme;
                const styleOverrides = (_b = (_a = theme.components) == null ? void 0 : _a[componentName]) == null ? void 0 : _b.styleOverrides;
                if (!styleOverrides) {
                  return null;
                }
                const resolvedStyleOverrides = {};
                for (const slotKey in styleOverrides) {
                  resolvedStyleOverrides[slotKey] = processStyle(props, styleOverrides[slotKey]);
                }
                return overridesResolver(props, resolvedStyleOverrides);
              });
            }
            if (componentName && !skipVariantsResolver) {
              expressionsTail.push(function styleThemeVariants(props) {
                var _a, _b;
                const theme = props.theme;
                const themeVariants = (_b = (_a = theme == null ? void 0 : theme.components) == null ? void 0 : _a[componentName]) == null ? void 0 : _b.variants;
                if (!themeVariants) {
                  return null;
                }
                return processStyleVariants(props, themeVariants);
              });
            }
            if (!skipSx) {
              expressionsTail.push(styleFunctionSx);
            }
            if (Array.isArray(expressionsBody[0])) {
              const inputStrings = expressionsBody.shift();
              const placeholdersHead = new Array(expressionsHead.length).fill("");
              const placeholdersTail = new Array(expressionsTail.length).fill("");
              let outputStrings;
              {
                outputStrings = [...placeholdersHead, ...inputStrings, ...placeholdersTail];
                outputStrings.raw = [...placeholdersHead, ...inputStrings.raw, ...placeholdersTail];
              }
              expressionsHead.unshift(outputStrings);
            }
            const expressions = [...expressionsHead, ...expressionsBody, ...expressionsTail];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) {
              Component.muiName = tag.muiName;
            }
            return Component;
          };
          if (defaultStyledResolver.withConfig) {
            muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
          }
          return muiStyledResolver;
        };
        return styled2;
      }
      function generateStyledLabel(componentName, componentSlot) {
        let label;
        return label;
      }
      function isObjectEmpty(object) {
        for (const _ in object) {
          return false;
        }
        return true;
      }
      function isStringTag(tag) {
        return typeof tag === "string" && // 96 is one less than the char code
        // for "a" so this is checking that
        // it's a lowercase character
        tag.charCodeAt(0) > 96;
      }
      function lowercaseFirstLetter(string) {
        if (!string) {
          return string;
        }
        return string.charAt(0).toLowerCase() + string.slice(1);
      }
      function resolveProps(defaultProps, props) {
        const output = {
          ...props
        };
        for (const key in defaultProps) {
          if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
            const propName = key;
            if (propName === "components" || propName === "slots") {
              output[propName] = {
                ...defaultProps[propName],
                ...output[propName]
              };
            } else if (propName === "componentsProps" || propName === "slotProps") {
              const defaultSlotProps = defaultProps[propName];
              const slotProps = props[propName];
              if (!slotProps) {
                output[propName] = defaultSlotProps || {};
              } else if (!defaultSlotProps) {
                output[propName] = slotProps;
              } else {
                output[propName] = {
                  ...slotProps
                };
                for (const slotKey in defaultSlotProps) {
                  if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                  }
                }
              }
            } else if (output[propName] === void 0) {
              output[propName] = defaultProps[propName];
            }
          }
        }
        return output;
      }
      function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
        return Math.max(min, Math.min(val, max));
      }
      function clampWrapper(value, min = 0, max = 1) {
        return clamp(value, min, max);
      }
      function hexToRgb(color2) {
        color2 = color2.slice(1);
        const re = new RegExp(`.{1,${color2.length >= 6 ? 2 : 1}}`, "g");
        let colors = color2.match(re);
        if (colors && colors[0].length === 1) {
          colors = colors.map((n) => n + n);
        }
        return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index) => {
          return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3;
        }).join(", ")})` : "";
      }
      function decomposeColor(color2) {
        if (color2.type) {
          return color2;
        }
        if (color2.charAt(0) === "#") {
          return decomposeColor(hexToRgb(color2));
        }
        const marker = color2.indexOf("(");
        const type = color2.substring(0, marker);
        if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(type)) {
          throw new Error(formatMuiErrorMessage(9, color2));
        }
        let values2 = color2.substring(marker + 1, color2.length - 1);
        let colorSpace;
        if (type === "color") {
          values2 = values2.split(" ");
          colorSpace = values2.shift();
          if (values2.length === 4 && values2[3].charAt(0) === "/") {
            values2[3] = values2[3].slice(1);
          }
          if (!["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(colorSpace)) {
            throw new Error(formatMuiErrorMessage(10, colorSpace));
          }
        } else {
          values2 = values2.split(",");
        }
        values2 = values2.map((value) => parseFloat(value));
        return {
          type,
          values: values2,
          colorSpace
        };
      }
      const colorChannel = (color2) => {
        const decomposedColor = decomposeColor(color2);
        return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.includes("hsl") && idx !== 0 ? `${val}%` : val).join(" ");
      };
      const private_safeColorChannel = (color2, warning) => {
        try {
          return colorChannel(color2);
        } catch (error) {
          return color2;
        }
      };
      function recomposeColor(color2) {
        const {
          type,
          colorSpace
        } = color2;
        let {
          values: values2
        } = color2;
        if (type.includes("rgb")) {
          values2 = values2.map((n, i) => i < 3 ? parseInt(n, 10) : n);
        } else if (type.includes("hsl")) {
          values2[1] = `${values2[1]}%`;
          values2[2] = `${values2[2]}%`;
        }
        if (type.includes("color")) {
          values2 = `${colorSpace} ${values2.join(" ")}`;
        } else {
          values2 = `${values2.join(", ")}`;
        }
        return `${type}(${values2})`;
      }
      function hslToRgb(color2) {
        color2 = decomposeColor(color2);
        const {
          values: values2
        } = color2;
        const h = values2[0];
        const s = values2[1] / 100;
        const l = values2[2] / 100;
        const a = s * Math.min(l, 1 - l);
        const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        let type = "rgb";
        const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
        if (color2.type === "hsla") {
          type += "a";
          rgb.push(values2[3]);
        }
        return recomposeColor({
          type,
          values: rgb
        });
      }
      function getLuminance(color2) {
        color2 = decomposeColor(color2);
        let rgb = color2.type === "hsl" || color2.type === "hsla" ? decomposeColor(hslToRgb(color2)).values : color2.values;
        rgb = rgb.map((val) => {
          if (color2.type !== "color") {
            val /= 255;
          }
          return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
        });
        return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
      }
      function getContrastRatio(foreground, background) {
        const lumA = getLuminance(foreground);
        const lumB = getLuminance(background);
        return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
      }
      function alpha(color2, value) {
        color2 = decomposeColor(color2);
        value = clampWrapper(value);
        if (color2.type === "rgb" || color2.type === "hsl") {
          color2.type += "a";
        }
        if (color2.type === "color") {
          color2.values[3] = `/${value}`;
        } else {
          color2.values[3] = value;
        }
        return recomposeColor(color2);
      }
      function private_safeAlpha(color2, value, warning) {
        try {
          return alpha(color2, value);
        } catch (error) {
          return color2;
        }
      }
      function darken(color2, coefficient) {
        color2 = decomposeColor(color2);
        coefficient = clampWrapper(coefficient);
        if (color2.type.includes("hsl")) {
          color2.values[2] *= 1 - coefficient;
        } else if (color2.type.includes("rgb") || color2.type.includes("color")) {
          for (let i = 0; i < 3; i += 1) {
            color2.values[i] *= 1 - coefficient;
          }
        }
        return recomposeColor(color2);
      }
      function private_safeDarken(color2, coefficient, warning) {
        try {
          return darken(color2, coefficient);
        } catch (error) {
          return color2;
        }
      }
      function lighten(color2, coefficient) {
        color2 = decomposeColor(color2);
        coefficient = clampWrapper(coefficient);
        if (color2.type.includes("hsl")) {
          color2.values[2] += (100 - color2.values[2]) * coefficient;
        } else if (color2.type.includes("rgb")) {
          for (let i = 0; i < 3; i += 1) {
            color2.values[i] += (255 - color2.values[i]) * coefficient;
          }
        } else if (color2.type.includes("color")) {
          for (let i = 0; i < 3; i += 1) {
            color2.values[i] += (1 - color2.values[i]) * coefficient;
          }
        }
        return recomposeColor(color2);
      }
      function private_safeLighten(color2, coefficient, warning) {
        try {
          return lighten(color2, coefficient);
        } catch (error) {
          return color2;
        }
      }
      function emphasize(color2, coefficient = 0.15) {
        return getLuminance(color2) > 0.5 ? darken(color2, coefficient) : lighten(color2, coefficient);
      }
      function private_safeEmphasize(color2, coefficient, warning) {
        try {
          return emphasize(color2, coefficient);
        } catch (error) {
          return color2;
        }
      }
      function composeClasses(slots, getUtilityClass, classes = void 0) {
        const output = {};
        for (const slotName in slots) {
          const slot = slots[slotName];
          let buffer = "";
          let start = true;
          for (let i = 0; i < slot.length; i += 1) {
            const value = slot[i];
            if (value) {
              buffer += (start === true ? "" : " ") + getUtilityClass(value);
              start = false;
              if (classes && classes[value]) {
                buffer += " " + classes[value];
              }
            }
          }
          output[slotName] = buffer;
        }
        return output;
      }
      const PropsContext = /* @__PURE__ */ reactExports.createContext(void 0);
      function getThemeProps(params) {
        const {
          theme,
          name,
          props
        } = params;
        if (!theme || !theme.components || !theme.components[name]) {
          return props;
        }
        const config = theme.components[name];
        if (config.defaultProps) {
          return resolveProps(config.defaultProps, props);
        }
        if (!config.styleOverrides && !config.variants) {
          return resolveProps(config, props);
        }
        return props;
      }
      function useDefaultProps$1({
        props,
        name
      }) {
        const ctx = reactExports.useContext(PropsContext);
        return getThemeProps({
          props,
          name,
          theme: {
            components: ctx
          }
        });
      }
      const arg = {
        theme: void 0
      };
      function unstable_memoTheme(styleFn) {
        let lastValue;
        let lastTheme;
        return function styleMemoized(props) {
          let value = lastValue;
          if (value === void 0 || props.theme !== lastTheme) {
            arg.theme = props.theme;
            value = preprocessStyles(styleFn(arg));
            lastValue = value;
            lastTheme = props.theme;
          }
          return value;
        };
      }
      function createGetCssVar$1(prefix2 = "") {
        function appendVar(...vars) {
          if (!vars.length) {
            return "";
          }
          const value = vars[0];
          if (typeof value === "string" && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) {
            return `, var(--${prefix2 ? `${prefix2}-` : ""}${value}${appendVar(...vars.slice(1))})`;
          }
          return `, ${value}`;
        }
        const getCssVar = (field, ...fallbacks) => {
          return `var(--${prefix2 ? `${prefix2}-` : ""}${field}${appendVar(...fallbacks)})`;
        };
        return getCssVar;
      }
      const assignNestedKeys = (obj, keys, value, arrayKeys = []) => {
        let temp = obj;
        keys.forEach((k, index) => {
          if (index === keys.length - 1) {
            if (Array.isArray(temp)) {
              temp[Number(k)] = value;
            } else if (temp && typeof temp === "object") {
              temp[k] = value;
            }
          } else if (temp && typeof temp === "object") {
            if (!temp[k]) {
              temp[k] = arrayKeys.includes(k) ? [] : {};
            }
            temp = temp[k];
          }
        });
      };
      const walkObjectDeep = (obj, callback, shouldSkipPaths) => {
        function recurse(object, parentKeys = [], arrayKeys = []) {
          Object.entries(object).forEach(([key, value]) => {
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([...parentKeys, key])) {
              if (value !== void 0 && value !== null) {
                if (typeof value === "object" && Object.keys(value).length > 0) {
                  recurse(value, [...parentKeys, key], Array.isArray(value) ? [...arrayKeys, key] : arrayKeys);
                } else {
                  callback([...parentKeys, key], value, arrayKeys);
                }
              }
            }
          });
        }
        recurse(obj);
      };
      const getCssValue = (keys, value) => {
        if (typeof value === "number") {
          if (["lineHeight", "fontWeight", "opacity", "zIndex"].some((prop) => keys.includes(prop))) {
            return value;
          }
          const lastKey = keys[keys.length - 1];
          if (lastKey.toLowerCase().includes("opacity")) {
            return value;
          }
          return `${value}px`;
        }
        return value;
      };
      function cssVarsParser(theme, options) {
        const {
          prefix: prefix2,
          shouldSkipGeneratingVar: shouldSkipGeneratingVar2
        } = options || {};
        const css = {};
        const vars = {};
        const varsWithDefaults = {};
        walkObjectDeep(
          theme,
          (keys, value, arrayKeys) => {
            if (typeof value === "string" || typeof value === "number") {
              if (!shouldSkipGeneratingVar2 || !shouldSkipGeneratingVar2(keys, value)) {
                const cssVar = `--${prefix2 ? `${prefix2}-` : ""}${keys.join("-")}`;
                const resolvedValue = getCssValue(keys, value);
                Object.assign(css, {
                  [cssVar]: resolvedValue
                });
                assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
              }
            }
          },
          (keys) => keys[0] === "vars"
          // skip 'vars/*' paths
        );
        return {
          css,
          vars,
          varsWithDefaults
        };
      }
      function prepareCssVars(theme, parserConfig = {}) {
        const {
          getSelector = defaultGetSelector2,
          disableCssColorScheme,
          colorSchemeSelector: selector
        } = parserConfig;
        const {
          colorSchemes = {},
          components,
          defaultColorScheme = "light",
          ...otherTheme
        } = theme;
        const {
          vars: rootVars,
          css: rootCss,
          varsWithDefaults: rootVarsWithDefaults
        } = cssVarsParser(otherTheme, parserConfig);
        let themeVars = rootVarsWithDefaults;
        const colorSchemesMap = {};
        const {
          [defaultColorScheme]: defaultScheme,
          ...otherColorSchemes
        } = colorSchemes;
        Object.entries(otherColorSchemes || {}).forEach(([key, scheme]) => {
          const {
            vars,
            css,
            varsWithDefaults
          } = cssVarsParser(scheme, parserConfig);
          themeVars = deepmerge(themeVars, varsWithDefaults);
          colorSchemesMap[key] = {
            css,
            vars
          };
        });
        if (defaultScheme) {
          const {
            css,
            vars,
            varsWithDefaults
          } = cssVarsParser(defaultScheme, parserConfig);
          themeVars = deepmerge(themeVars, varsWithDefaults);
          colorSchemesMap[defaultColorScheme] = {
            css,
            vars
          };
        }
        function defaultGetSelector2(colorScheme, cssObject) {
          var _a, _b;
          let rule = selector;
          if (selector === "class") {
            rule = ".%s";
          }
          if (selector === "data") {
            rule = "[data-%s]";
          }
          if ((selector == null ? void 0 : selector.startsWith("data-")) && !selector.includes("%s")) {
            rule = `[${selector}="%s"]`;
          }
          if (colorScheme) {
            if (rule === "media") {
              if (theme.defaultColorScheme === colorScheme) {
                return ":root";
              }
              const mode = ((_b = (_a = colorSchemes[colorScheme]) == null ? void 0 : _a.palette) == null ? void 0 : _b.mode) || colorScheme;
              return {
                [`@media (prefers-color-scheme: ${mode})`]: {
                  ":root": cssObject
                }
              };
            }
            if (rule) {
              if (theme.defaultColorScheme === colorScheme) {
                return `:root, ${rule.replace("%s", String(colorScheme))}`;
              }
              return rule.replace("%s", String(colorScheme));
            }
          }
          return ":root";
        }
        const generateThemeVars = () => {
          let vars = {
            ...rootVars
          };
          Object.entries(colorSchemesMap).forEach(([, {
            vars: schemeVars
          }]) => {
            vars = deepmerge(vars, schemeVars);
          });
          return vars;
        };
        const generateStyleSheets = () => {
          var _a, _b;
          const stylesheets = [];
          const colorScheme = theme.defaultColorScheme || "light";
          function insertStyleSheet(key, css) {
            if (Object.keys(css).length) {
              stylesheets.push(typeof key === "string" ? {
                [key]: {
                  ...css
                }
              } : key);
            }
          }
          insertStyleSheet(getSelector(void 0, {
            ...rootCss
          }), rootCss);
          const {
            [colorScheme]: defaultSchemeVal,
            ...other
          } = colorSchemesMap;
          if (defaultSchemeVal) {
            const {
              css
            } = defaultSchemeVal;
            const cssColorSheme = (_b = (_a = colorSchemes[colorScheme]) == null ? void 0 : _a.palette) == null ? void 0 : _b.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
              colorScheme: cssColorSheme,
              ...css
            } : {
              ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
              ...finalCss
            }), finalCss);
          }
          Object.entries(other).forEach(([key, {
            css
          }]) => {
            var _a2, _b2;
            const cssColorSheme = (_b2 = (_a2 = colorSchemes[key]) == null ? void 0 : _a2.palette) == null ? void 0 : _b2.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
              colorScheme: cssColorSheme,
              ...css
            } : {
              ...css
            };
            insertStyleSheet(getSelector(key, {
              ...finalCss
            }), finalCss);
          });
          return stylesheets;
        };
        return {
          vars: themeVars,
          generateThemeVars,
          generateStyleSheets
        };
      }
      function createGetColorSchemeSelector(selector) {
        return function getColorSchemeSelector(colorScheme) {
          if (selector === "media") {
            return `@media (prefers-color-scheme: ${colorScheme})`;
          }
          if (selector) {
            if (selector.startsWith("data-") && !selector.includes("%s")) {
              return `[${selector}="${colorScheme}"] &`;
            }
            if (selector === "class") {
              return `.${colorScheme} &`;
            }
            if (selector === "data") {
              return `[data-${colorScheme}] &`;
            }
            return `${selector.replace("%s", colorScheme)} &`;
          }
          return "&";
        };
      }
      function getLight() {
        return {
          // The colors used to style the text.
          text: {
            // The most important text.
            primary: "rgba(0, 0, 0, 0.87)",
            // Secondary text.
            secondary: "rgba(0, 0, 0, 0.6)",
            // Disabled text have even lower visual prominence.
            disabled: "rgba(0, 0, 0, 0.38)"
          },
          // The color used to divide different elements.
          divider: "rgba(0, 0, 0, 0.12)",
          // The background colors used to style the surfaces.
          // Consistency between these values is important.
          background: {
            paper: common.white,
            default: common.white
          },
          // The colors used to style the action elements.
          action: {
            // The color of an active action like an icon button.
            active: "rgba(0, 0, 0, 0.54)",
            // The color of an hovered action.
            hover: "rgba(0, 0, 0, 0.04)",
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: "rgba(0, 0, 0, 0.08)",
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: "rgba(0, 0, 0, 0.26)",
            // The background color of a disabled action.
            disabledBackground: "rgba(0, 0, 0, 0.12)",
            disabledOpacity: 0.38,
            focus: "rgba(0, 0, 0, 0.12)",
            focusOpacity: 0.12,
            activatedOpacity: 0.12
          }
        };
      }
      const light = getLight();
      function getDark() {
        return {
          text: {
            primary: common.white,
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(255, 255, 255, 0.5)",
            icon: "rgba(255, 255, 255, 0.5)"
          },
          divider: "rgba(255, 255, 255, 0.12)",
          background: {
            paper: "#121212",
            default: "#121212"
          },
          action: {
            active: common.white,
            hover: "rgba(255, 255, 255, 0.08)",
            hoverOpacity: 0.08,
            selected: "rgba(255, 255, 255, 0.16)",
            selectedOpacity: 0.16,
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            disabledOpacity: 0.38,
            focus: "rgba(255, 255, 255, 0.12)",
            focusOpacity: 0.12,
            activatedOpacity: 0.24
          }
        };
      }
      const dark = getDark();
      function addLightOrDark(intent, direction, shade, tonalOffset) {
        const tonalOffsetLight = tonalOffset.light || tonalOffset;
        const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
        if (!intent[direction]) {
          if (intent.hasOwnProperty(shade)) {
            intent[direction] = intent[shade];
          } else if (direction === "light") {
            intent.light = lighten(intent.main, tonalOffsetLight);
          } else if (direction === "dark") {
            intent.dark = darken(intent.main, tonalOffsetDark);
          }
        }
      }
      function getDefaultPrimary(mode = "light") {
        if (mode === "dark") {
          return {
            main: blue[200],
            light: blue[50],
            dark: blue[400]
          };
        }
        return {
          main: blue[700],
          light: blue[400],
          dark: blue[800]
        };
      }
      function getDefaultSecondary(mode = "light") {
        if (mode === "dark") {
          return {
            main: purple[200],
            light: purple[50],
            dark: purple[400]
          };
        }
        return {
          main: purple[500],
          light: purple[300],
          dark: purple[700]
        };
      }
      function getDefaultError(mode = "light") {
        if (mode === "dark") {
          return {
            main: red[500],
            light: red[300],
            dark: red[700]
          };
        }
        return {
          main: red[700],
          light: red[400],
          dark: red[800]
        };
      }
      function getDefaultInfo(mode = "light") {
        if (mode === "dark") {
          return {
            main: lightBlue[400],
            light: lightBlue[300],
            dark: lightBlue[700]
          };
        }
        return {
          main: lightBlue[700],
          light: lightBlue[500],
          dark: lightBlue[900]
        };
      }
      function getDefaultSuccess(mode = "light") {
        if (mode === "dark") {
          return {
            main: green[400],
            light: green[300],
            dark: green[700]
          };
        }
        return {
          main: green[800],
          light: green[500],
          dark: green[900]
        };
      }
      function getDefaultWarning(mode = "light") {
        if (mode === "dark") {
          return {
            main: orange[400],
            light: orange[300],
            dark: orange[700]
          };
        }
        return {
          main: "#ed6c02",
          // closest to orange[800] that pass 3:1.
          light: orange[500],
          dark: orange[900]
        };
      }
      function createPalette(palette) {
        const {
          mode = "light",
          contrastThreshold = 3,
          tonalOffset = 0.2,
          ...other
        } = palette;
        const primary = palette.primary || getDefaultPrimary(mode);
        const secondary = palette.secondary || getDefaultSecondary(mode);
        const error = palette.error || getDefaultError(mode);
        const info = palette.info || getDefaultInfo(mode);
        const success = palette.success || getDefaultSuccess(mode);
        const warning = palette.warning || getDefaultWarning(mode);
        function getContrastText(background) {
          const contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
          return contrastText;
        }
        const augmentColor = ({
          color: color2,
          name,
          mainShade = 500,
          lightShade = 300,
          darkShade = 700
        }) => {
          color2 = {
            ...color2
          };
          if (!color2.main && color2[mainShade]) {
            color2.main = color2[mainShade];
          }
          if (!color2.hasOwnProperty("main")) {
            throw new Error(formatMuiErrorMessage(11, name ? ` (${name})` : "", mainShade));
          }
          if (typeof color2.main !== "string") {
            throw new Error(formatMuiErrorMessage(12, name ? ` (${name})` : "", JSON.stringify(color2.main)));
          }
          addLightOrDark(color2, "light", lightShade, tonalOffset);
          addLightOrDark(color2, "dark", darkShade, tonalOffset);
          if (!color2.contrastText) {
            color2.contrastText = getContrastText(color2.main);
          }
          return color2;
        };
        let modeHydrated;
        if (mode === "light") {
          modeHydrated = getLight();
        } else if (mode === "dark") {
          modeHydrated = getDark();
        }
        const paletteOutput = deepmerge({
          // A collection of common colors.
          common: {
            ...common
          },
          // prevent mutable object.
          // The palette mode, can be light or dark.
          mode,
          // The colors used to represent primary interface elements for a user.
          primary: augmentColor({
            color: primary,
            name: "primary"
          }),
          // The colors used to represent secondary interface elements for a user.
          secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
          }),
          // The colors used to represent interface elements that the user should be made aware of.
          error: augmentColor({
            color: error,
            name: "error"
          }),
          // The colors used to represent potentially dangerous actions or important messages.
          warning: augmentColor({
            color: warning,
            name: "warning"
          }),
          // The colors used to present information to the user that is neutral and not necessarily important.
          info: augmentColor({
            color: info,
            name: "info"
          }),
          // The colors used to indicate the successful completion of an action that user triggered.
          success: augmentColor({
            color: success,
            name: "success"
          }),
          // The grey colors.
          grey,
          // Used by `getContrastText()` to maximize the contrast between
          // the background and the text.
          contrastThreshold,
          // Takes a background color and returns the text color that maximizes the contrast.
          getContrastText,
          // Generate a rich color object.
          augmentColor,
          // Used by the functions below to shift a color's luminance by approximately
          // two indexes within its tonal palette.
          // E.g., shift from Red 500 to Red 300 or Red 700.
          tonalOffset,
          // The light and dark mode object.
          ...modeHydrated
        }, other);
        return paletteOutput;
      }
      function prepareTypographyVars(typography) {
        const vars = {};
        const entries = Object.entries(typography);
        entries.forEach((entry) => {
          const [key, value] = entry;
          if (typeof value === "object") {
            vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ""}${value.fontVariant ? `${value.fontVariant} ` : ""}${value.fontWeight ? `${value.fontWeight} ` : ""}${value.fontStretch ? `${value.fontStretch} ` : ""}${value.fontSize || ""}${value.lineHeight ? `/${value.lineHeight} ` : ""}${value.fontFamily || ""}`;
          }
        });
        return vars;
      }
      function createMixins(breakpoints, mixins) {
        return {
          toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
              "@media (orientation: landscape)": {
                minHeight: 48
              }
            },
            [breakpoints.up("sm")]: {
              minHeight: 64
            }
          },
          ...mixins
        };
      }
      function round(value) {
        return Math.round(value * 1e5) / 1e5;
      }
      const caseAllCaps = {
        textTransform: "uppercase"
      };
      const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
      function createTypography(palette, typography) {
        const {
          fontFamily = defaultFontFamily,
          // The default font size of the Material Specification.
          fontSize = 14,
          // px
          fontWeightLight = 300,
          fontWeightRegular = 400,
          fontWeightMedium = 500,
          fontWeightBold = 700,
          // Tell MUI what's the font-size on the html element.
          // 16px is the default font-size used by browsers.
          htmlFontSize = 16,
          // Apply the CSS properties to all the variants.
          allVariants,
          pxToRem: pxToRem2,
          ...other
        } = typeof typography === "function" ? typography(palette) : typography;
        const coef = fontSize / 14;
        const pxToRem = pxToRem2 || ((size) => `${size / htmlFontSize * coef}rem`);
        const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => ({
          fontFamily,
          fontWeight,
          fontSize: pxToRem(size),
          // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
          lineHeight,
          // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
          // across font-families can cause issues with the kerning.
          ...fontFamily === defaultFontFamily ? {
            letterSpacing: `${round(letterSpacing / size)}em`
          } : {},
          ...casing,
          ...allVariants
        });
        const variants = {
          h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
          h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
          h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
          h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
          h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
          h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
          subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
          subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
          body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
          body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
          button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
          caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
          overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
          // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
          inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
          }
        };
        return deepmerge({
          htmlFontSize,
          pxToRem,
          fontFamily,
          fontSize,
          fontWeightLight,
          fontWeightRegular,
          fontWeightMedium,
          fontWeightBold,
          ...variants
        }, other, {
          clone: false
          // No need to clone deep
        });
      }
      const shadowKeyUmbraOpacity = 0.2;
      const shadowKeyPenumbraOpacity = 0.14;
      const shadowAmbientShadowOpacity = 0.12;
      function createShadow(...px) {
        return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
      }
      const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
      const easing = {
        // This is the most common easing curve.
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        // Objects enter the screen at full velocity from off-screen and
        // slowly decelerate to a resting point.
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        // Objects leave the screen at full velocity. They do not decelerate when off-screen.
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        // The sharp curve is used by objects that may return to the screen at any time.
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
      };
      const duration = {
        shortest: 150,
        shorter: 200,
        short: 250,
        // most basic recommended timing
        standard: 300,
        // this is to be used in complex animations
        complex: 375,
        // recommended when something is entering screen
        enteringScreen: 225,
        // recommended when something is leaving screen
        leavingScreen: 195
      };
      function formatMs(milliseconds) {
        return `${Math.round(milliseconds)}ms`;
      }
      function getAutoHeightDuration(height2) {
        if (!height2) {
          return 0;
        }
        const constant = height2 / 36;
        return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3e3);
      }
      function createTransitions(inputTransitions) {
        const mergedEasing = {
          ...easing,
          ...inputTransitions.easing
        };
        const mergedDuration = {
          ...duration,
          ...inputTransitions.duration
        };
        const create = (props = ["all"], options = {}) => {
          const {
            duration: durationOption = mergedDuration.standard,
            easing: easingOption = mergedEasing.easeInOut,
            delay = 0,
            ...other
          } = options;
          return (Array.isArray(props) ? props : [props]).map((animatedProp) => `${animatedProp} ${typeof durationOption === "string" ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : formatMs(delay)}`).join(",");
        };
        return {
          getAutoHeightDuration,
          create,
          ...inputTransitions,
          easing: mergedEasing,
          duration: mergedDuration
        };
      }
      const zIndex = {
        mobileStepper: 1e3,
        fab: 1050,
        speedDial: 1050,
        appBar: 1100,
        drawer: 1200,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500
      };
      function isSerializable(val) {
        return isPlainObject(val) || typeof val === "undefined" || typeof val === "string" || typeof val === "boolean" || typeof val === "number" || Array.isArray(val);
      }
      function stringifyTheme(baseTheme = {}) {
        const serializableTheme = {
          ...baseTheme
        };
        function serializeTheme(object) {
          const array = Object.entries(object);
          for (let index = 0; index < array.length; index++) {
            const [key, value] = array[index];
            if (!isSerializable(value) || key.startsWith("unstable_")) {
              delete object[key];
            } else if (isPlainObject(value)) {
              object[key] = {
                ...value
              };
              serializeTheme(object[key]);
            }
          }
        }
        serializeTheme(serializableTheme);
        return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
      }
      function createThemeNoVars(options = {}, ...args) {
        const {
          breakpoints: breakpointsInput,
          mixins: mixinsInput = {},
          spacing: spacingInput,
          palette: paletteInput = {},
          transitions: transitionsInput = {},
          typography: typographyInput = {},
          shape: shapeInput,
          ...other
        } = options;
        if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
        // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
        options.generateThemeVars === void 0) {
          throw new Error(formatMuiErrorMessage(20));
        }
        const palette = createPalette(paletteInput);
        const systemTheme = createTheme$1(options);
        let muiTheme = deepmerge(systemTheme, {
          mixins: createMixins(systemTheme.breakpoints, mixinsInput),
          palette,
          // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
          shadows: shadows.slice(),
          typography: createTypography(palette, typographyInput),
          transitions: createTransitions(transitionsInput),
          zIndex: {
            ...zIndex
          }
        });
        muiTheme = deepmerge(muiTheme, other);
        muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
        muiTheme.unstable_sxConfig = {
          ...defaultSxConfig,
          ...other == null ? void 0 : other.unstable_sxConfig
        };
        muiTheme.unstable_sx = function sx(props) {
          return styleFunctionSx({
            sx: props,
            theme: this
          });
        };
        muiTheme.toRuntimeSource = stringifyTheme;
        return muiTheme;
      }
      function getOverlayAlpha(elevation) {
        let alphaValue;
        if (elevation < 1) {
          alphaValue = 5.11916 * elevation ** 2;
        } else {
          alphaValue = 4.5 * Math.log(elevation + 1) + 2;
        }
        return Math.round(alphaValue * 10) / 1e3;
      }
      const defaultDarkOverlays = [...Array(25)].map((_, index) => {
        if (index === 0) {
          return "none";
        }
        const overlay = getOverlayAlpha(index);
        return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
      });
      function getOpacity(mode) {
        return {
          inputPlaceholder: mode === "dark" ? 0.5 : 0.42,
          inputUnderline: mode === "dark" ? 0.7 : 0.42,
          switchTrackDisabled: mode === "dark" ? 0.2 : 0.12,
          switchTrack: mode === "dark" ? 0.3 : 0.38
        };
      }
      function getOverlays(mode) {
        return mode === "dark" ? defaultDarkOverlays : [];
      }
      function createColorScheme(options) {
        const {
          palette: paletteInput = {
            mode: "light"
          },
          // need to cast to avoid module augmentation test
          opacity,
          overlays,
          ...rest
        } = options;
        const palette = createPalette(paletteInput);
        return {
          palette,
          opacity: {
            ...getOpacity(palette.mode),
            ...opacity
          },
          overlays: overlays || getOverlays(palette.mode),
          ...rest
        };
      }
      function shouldSkipGeneratingVar(keys) {
        var _a;
        return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
        keys[0] === "palette" && !!((_a = keys[1]) == null ? void 0 : _a.match(/(mode|contrastThreshold|tonalOffset)/));
      }
      const excludeVariablesFromRoot = (cssVarPrefix) => [...[...Array(25)].map((_, index) => `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}overlays-${index}`), `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkBg`, `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkColor`];
      const defaultGetSelector = (theme) => (colorScheme, css) => {
        const root = theme.rootSelector || ":root";
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === "class") {
          rule = ".%s";
        }
        if (selector === "data") {
          rule = "[data-%s]";
        }
        if ((selector == null ? void 0 : selector.startsWith("data-")) && !selector.includes("%s")) {
          rule = `[${selector}="%s"]`;
        }
        if (theme.defaultColorScheme === colorScheme) {
          if (colorScheme === "dark") {
            const excludedVariables = {};
            excludeVariablesFromRoot(theme.cssVarPrefix).forEach((cssVar) => {
              excludedVariables[cssVar] = css[cssVar];
              delete css[cssVar];
            });
            if (rule === "media") {
              return {
                [root]: css,
                [`@media (prefers-color-scheme: dark)`]: {
                  [root]: excludedVariables
                }
              };
            }
            if (rule) {
              return {
                [rule.replace("%s", colorScheme)]: excludedVariables,
                [`${root}, ${rule.replace("%s", colorScheme)}`]: css
              };
            }
            return {
              [root]: {
                ...css,
                ...excludedVariables
              }
            };
          }
          if (rule && rule !== "media") {
            return `${root}, ${rule.replace("%s", String(colorScheme))}`;
          }
        } else if (colorScheme) {
          if (rule === "media") {
            return {
              [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                [root]: css
              }
            };
          }
          if (rule) {
            return rule.replace("%s", String(colorScheme));
          }
        }
        return root;
      };
      function assignNode(obj, keys) {
        keys.forEach((k) => {
          if (!obj[k]) {
            obj[k] = {};
          }
        });
      }
      function setColor(obj, key, defaultValue) {
        if (!obj[key] && defaultValue) {
          obj[key] = defaultValue;
        }
      }
      function toRgb(color2) {
        if (typeof color2 !== "string" || !color2.startsWith("hsl")) {
          return color2;
        }
        return hslToRgb(color2);
      }
      function setColorChannel(obj, key) {
        if (!(`${key}Channel` in obj)) {
          obj[`${key}Channel`] = private_safeColorChannel(toRgb(obj[key]));
        }
      }
      function getSpacingVal(spacingInput) {
        if (typeof spacingInput === "number") {
          return `${spacingInput}px`;
        }
        if (typeof spacingInput === "string" || typeof spacingInput === "function" || Array.isArray(spacingInput)) {
          return spacingInput;
        }
        return "8px";
      }
      const silent = (fn) => {
        try {
          return fn();
        } catch (error) {
        }
        return void 0;
      };
      const createGetCssVar = (cssVarPrefix = "mui") => createGetCssVar$1(cssVarPrefix);
      function attachColorScheme$1(colorSchemes, scheme, restTheme, colorScheme) {
        if (!scheme) {
          return void 0;
        }
        scheme = scheme === true ? {} : scheme;
        const mode = colorScheme === "dark" ? "dark" : "light";
        if (!restTheme) {
          colorSchemes[colorScheme] = createColorScheme({
            ...scheme,
            palette: {
              mode,
              ...scheme == null ? void 0 : scheme.palette
            }
          });
          return void 0;
        }
        const {
          palette,
          ...muiTheme
        } = createThemeNoVars({
          ...restTheme,
          palette: {
            mode,
            ...scheme == null ? void 0 : scheme.palette
          }
        });
        colorSchemes[colorScheme] = {
          ...scheme,
          palette,
          opacity: {
            ...getOpacity(mode),
            ...scheme == null ? void 0 : scheme.opacity
          },
          overlays: (scheme == null ? void 0 : scheme.overlays) || getOverlays(mode)
        };
        return muiTheme;
      }
      function createThemeWithVars(options = {}, ...args) {
        const {
          colorSchemes: colorSchemesInput = {
            light: true
          },
          defaultColorScheme: defaultColorSchemeInput,
          disableCssColorScheme = false,
          cssVarPrefix = "mui",
          shouldSkipGeneratingVar: shouldSkipGeneratingVar$1 = shouldSkipGeneratingVar,
          colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? "media" : void 0,
          rootSelector = ":root",
          ...input
        } = options;
        const firstColorScheme = Object.keys(colorSchemesInput)[0];
        const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== "light" ? "light" : firstColorScheme);
        const getCssVar = createGetCssVar(cssVarPrefix);
        const {
          [defaultColorScheme]: defaultSchemeInput,
          light: builtInLight,
          dark: builtInDark,
          ...customColorSchemes
        } = colorSchemesInput;
        const colorSchemes = {
          ...customColorSchemes
        };
        let defaultScheme = defaultSchemeInput;
        if (defaultColorScheme === "dark" && !("dark" in colorSchemesInput) || defaultColorScheme === "light" && !("light" in colorSchemesInput)) {
          defaultScheme = true;
        }
        if (!defaultScheme) {
          throw new Error(formatMuiErrorMessage(21, defaultColorScheme));
        }
        const muiTheme = attachColorScheme$1(colorSchemes, defaultScheme, input, defaultColorScheme);
        if (builtInLight && !colorSchemes.light) {
          attachColorScheme$1(colorSchemes, builtInLight, void 0, "light");
        }
        if (builtInDark && !colorSchemes.dark) {
          attachColorScheme$1(colorSchemes, builtInDark, void 0, "dark");
        }
        let theme = {
          defaultColorScheme,
          ...muiTheme,
          cssVarPrefix,
          colorSchemeSelector: selector,
          rootSelector,
          getCssVar,
          colorSchemes,
          font: {
            ...prepareTypographyVars(muiTheme.typography),
            ...muiTheme.font
          },
          spacing: getSpacingVal(input.spacing)
        };
        Object.keys(theme.colorSchemes).forEach((key) => {
          const palette = theme.colorSchemes[key].palette;
          const setCssVarColor = (cssVar) => {
            const tokens = cssVar.split("-");
            const color2 = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color2][colorToken]);
          };
          if (palette.mode === "light") {
            setColor(palette.common, "background", "#fff");
            setColor(palette.common, "onBackground", "#000");
          }
          if (palette.mode === "dark") {
            setColor(palette.common, "background", "#000");
            setColor(palette.common, "onBackground", "#fff");
          }
          assignNode(palette, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]);
          if (palette.mode === "light") {
            setColor(palette.Alert, "errorColor", private_safeDarken(palette.error.light, 0.6));
            setColor(palette.Alert, "infoColor", private_safeDarken(palette.info.light, 0.6));
            setColor(palette.Alert, "successColor", private_safeDarken(palette.success.light, 0.6));
            setColor(palette.Alert, "warningColor", private_safeDarken(palette.warning.light, 0.6));
            setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-main"));
            setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-main"));
            setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-main"));
            setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-main"));
            setColor(palette.Alert, "errorFilledColor", silent(() => palette.getContrastText(palette.error.main)));
            setColor(palette.Alert, "infoFilledColor", silent(() => palette.getContrastText(palette.info.main)));
            setColor(palette.Alert, "successFilledColor", silent(() => palette.getContrastText(palette.success.main)));
            setColor(palette.Alert, "warningFilledColor", silent(() => palette.getContrastText(palette.warning.main)));
            setColor(palette.Alert, "errorStandardBg", private_safeLighten(palette.error.light, 0.9));
            setColor(palette.Alert, "infoStandardBg", private_safeLighten(palette.info.light, 0.9));
            setColor(palette.Alert, "successStandardBg", private_safeLighten(palette.success.light, 0.9));
            setColor(palette.Alert, "warningStandardBg", private_safeLighten(palette.warning.light, 0.9));
            setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
            setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
            setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
            setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
            setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-100"));
            setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-400"));
            setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-300"));
            setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-A100"));
            setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-400"));
            setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-700"));
            setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-700"));
            setColor(palette.FilledInput, "bg", "rgba(0, 0, 0, 0.06)");
            setColor(palette.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)");
            setColor(palette.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)");
            setColor(palette.LinearProgress, "primaryBg", private_safeLighten(palette.primary.main, 0.62));
            setColor(palette.LinearProgress, "secondaryBg", private_safeLighten(palette.secondary.main, 0.62));
            setColor(palette.LinearProgress, "errorBg", private_safeLighten(palette.error.main, 0.62));
            setColor(palette.LinearProgress, "infoBg", private_safeLighten(palette.info.main, 0.62));
            setColor(palette.LinearProgress, "successBg", private_safeLighten(palette.success.main, 0.62));
            setColor(palette.LinearProgress, "warningBg", private_safeLighten(palette.warning.main, 0.62));
            setColor(palette.Skeleton, "bg", `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.11)`);
            setColor(palette.Slider, "primaryTrack", private_safeLighten(palette.primary.main, 0.62));
            setColor(palette.Slider, "secondaryTrack", private_safeLighten(palette.secondary.main, 0.62));
            setColor(palette.Slider, "errorTrack", private_safeLighten(palette.error.main, 0.62));
            setColor(palette.Slider, "infoTrack", private_safeLighten(palette.info.main, 0.62));
            setColor(palette.Slider, "successTrack", private_safeLighten(palette.success.main, 0.62));
            setColor(palette.Slider, "warningTrack", private_safeLighten(palette.warning.main, 0.62));
            const snackbarContentBackground = private_safeEmphasize(palette.background.default, 0.8);
            setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
            setColor(palette.SnackbarContent, "color", silent(() => palette.getContrastText(snackbarContentBackground)));
            setColor(palette.SpeedDialAction, "fabHoverBg", private_safeEmphasize(palette.background.paper, 0.15));
            setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-400"));
            setColor(palette.StepContent, "border", setCssVarColor("palette-grey-400"));
            setColor(palette.Switch, "defaultColor", setCssVarColor("palette-common-white"));
            setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-100"));
            setColor(palette.Switch, "primaryDisabledColor", private_safeLighten(palette.primary.main, 0.62));
            setColor(palette.Switch, "secondaryDisabledColor", private_safeLighten(palette.secondary.main, 0.62));
            setColor(palette.Switch, "errorDisabledColor", private_safeLighten(palette.error.main, 0.62));
            setColor(palette.Switch, "infoDisabledColor", private_safeLighten(palette.info.main, 0.62));
            setColor(palette.Switch, "successDisabledColor", private_safeLighten(palette.success.main, 0.62));
            setColor(palette.Switch, "warningDisabledColor", private_safeLighten(palette.warning.main, 0.62));
            setColor(palette.TableCell, "border", private_safeLighten(private_safeAlpha(palette.divider, 1), 0.88));
            setColor(palette.Tooltip, "bg", private_safeAlpha(palette.grey[700], 0.92));
          }
          if (palette.mode === "dark") {
            setColor(palette.Alert, "errorColor", private_safeLighten(palette.error.light, 0.6));
            setColor(palette.Alert, "infoColor", private_safeLighten(palette.info.light, 0.6));
            setColor(palette.Alert, "successColor", private_safeLighten(palette.success.light, 0.6));
            setColor(palette.Alert, "warningColor", private_safeLighten(palette.warning.light, 0.6));
            setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-dark"));
            setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-dark"));
            setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-dark"));
            setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-dark"));
            setColor(palette.Alert, "errorFilledColor", silent(() => palette.getContrastText(palette.error.dark)));
            setColor(palette.Alert, "infoFilledColor", silent(() => palette.getContrastText(palette.info.dark)));
            setColor(palette.Alert, "successFilledColor", silent(() => palette.getContrastText(palette.success.dark)));
            setColor(palette.Alert, "warningFilledColor", silent(() => palette.getContrastText(palette.warning.dark)));
            setColor(palette.Alert, "errorStandardBg", private_safeDarken(palette.error.light, 0.9));
            setColor(palette.Alert, "infoStandardBg", private_safeDarken(palette.info.light, 0.9));
            setColor(palette.Alert, "successStandardBg", private_safeDarken(palette.success.light, 0.9));
            setColor(palette.Alert, "warningStandardBg", private_safeDarken(palette.warning.light, 0.9));
            setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
            setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
            setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
            setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
            setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-900"));
            setColor(palette.AppBar, "darkBg", setCssVarColor("palette-background-paper"));
            setColor(palette.AppBar, "darkColor", setCssVarColor("palette-text-primary"));
            setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-600"));
            setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-800"));
            setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-700"));
            setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-700"));
            setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-300"));
            setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-300"));
            setColor(palette.FilledInput, "bg", "rgba(255, 255, 255, 0.09)");
            setColor(palette.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)");
            setColor(palette.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)");
            setColor(palette.LinearProgress, "primaryBg", private_safeDarken(palette.primary.main, 0.5));
            setColor(palette.LinearProgress, "secondaryBg", private_safeDarken(palette.secondary.main, 0.5));
            setColor(palette.LinearProgress, "errorBg", private_safeDarken(palette.error.main, 0.5));
            setColor(palette.LinearProgress, "infoBg", private_safeDarken(palette.info.main, 0.5));
            setColor(palette.LinearProgress, "successBg", private_safeDarken(palette.success.main, 0.5));
            setColor(palette.LinearProgress, "warningBg", private_safeDarken(palette.warning.main, 0.5));
            setColor(palette.Skeleton, "bg", `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.13)`);
            setColor(palette.Slider, "primaryTrack", private_safeDarken(palette.primary.main, 0.5));
            setColor(palette.Slider, "secondaryTrack", private_safeDarken(palette.secondary.main, 0.5));
            setColor(palette.Slider, "errorTrack", private_safeDarken(palette.error.main, 0.5));
            setColor(palette.Slider, "infoTrack", private_safeDarken(palette.info.main, 0.5));
            setColor(palette.Slider, "successTrack", private_safeDarken(palette.success.main, 0.5));
            setColor(palette.Slider, "warningTrack", private_safeDarken(palette.warning.main, 0.5));
            const snackbarContentBackground = private_safeEmphasize(palette.background.default, 0.98);
            setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
            setColor(palette.SnackbarContent, "color", silent(() => palette.getContrastText(snackbarContentBackground)));
            setColor(palette.SpeedDialAction, "fabHoverBg", private_safeEmphasize(palette.background.paper, 0.15));
            setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-600"));
            setColor(palette.StepContent, "border", setCssVarColor("palette-grey-600"));
            setColor(palette.Switch, "defaultColor", setCssVarColor("palette-grey-300"));
            setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-600"));
            setColor(palette.Switch, "primaryDisabledColor", private_safeDarken(palette.primary.main, 0.55));
            setColor(palette.Switch, "secondaryDisabledColor", private_safeDarken(palette.secondary.main, 0.55));
            setColor(palette.Switch, "errorDisabledColor", private_safeDarken(palette.error.main, 0.55));
            setColor(palette.Switch, "infoDisabledColor", private_safeDarken(palette.info.main, 0.55));
            setColor(palette.Switch, "successDisabledColor", private_safeDarken(palette.success.main, 0.55));
            setColor(palette.Switch, "warningDisabledColor", private_safeDarken(palette.warning.main, 0.55));
            setColor(palette.TableCell, "border", private_safeDarken(private_safeAlpha(palette.divider, 1), 0.68));
            setColor(palette.Tooltip, "bg", private_safeAlpha(palette.grey[700], 0.92));
          }
          setColorChannel(palette.background, "default");
          setColorChannel(palette.background, "paper");
          setColorChannel(palette.common, "background");
          setColorChannel(palette.common, "onBackground");
          setColorChannel(palette, "divider");
          Object.keys(palette).forEach((color2) => {
            const colors = palette[color2];
            if (color2 !== "tonalOffset" && colors && typeof colors === "object") {
              if (colors.main) {
                setColor(palette[color2], "mainChannel", private_safeColorChannel(toRgb(colors.main)));
              }
              if (colors.light) {
                setColor(palette[color2], "lightChannel", private_safeColorChannel(toRgb(colors.light)));
              }
              if (colors.dark) {
                setColor(palette[color2], "darkChannel", private_safeColorChannel(toRgb(colors.dark)));
              }
              if (colors.contrastText) {
                setColor(palette[color2], "contrastTextChannel", private_safeColorChannel(toRgb(colors.contrastText)));
              }
              if (color2 === "text") {
                setColorChannel(palette[color2], "primary");
                setColorChannel(palette[color2], "secondary");
              }
              if (color2 === "action") {
                if (colors.active) {
                  setColorChannel(palette[color2], "active");
                }
                if (colors.selected) {
                  setColorChannel(palette[color2], "selected");
                }
              }
            }
          });
        });
        theme = args.reduce((acc, argument) => deepmerge(acc, argument), theme);
        const parserConfig = {
          prefix: cssVarPrefix,
          disableCssColorScheme,
          shouldSkipGeneratingVar: shouldSkipGeneratingVar$1,
          getSelector: defaultGetSelector(theme)
        };
        const {
          vars,
          generateThemeVars,
          generateStyleSheets
        } = prepareCssVars(theme, parserConfig);
        theme.vars = vars;
        Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value]) => {
          theme[key] = value;
        });
        theme.generateThemeVars = generateThemeVars;
        theme.generateStyleSheets = generateStyleSheets;
        theme.generateSpacing = function generateSpacing() {
          return createSpacing(input.spacing, createUnarySpacing(this));
        };
        theme.getColorSchemeSelector = createGetColorSchemeSelector(selector);
        theme.spacing = theme.generateSpacing();
        theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar$1;
        theme.unstable_sxConfig = {
          ...defaultSxConfig,
          ...input == null ? void 0 : input.unstable_sxConfig
        };
        theme.unstable_sx = function sx(props) {
          return styleFunctionSx({
            sx: props,
            theme: this
          });
        };
        theme.toRuntimeSource = stringifyTheme;
        return theme;
      }
      function attachColorScheme(theme, scheme, colorScheme) {
        if (!theme.colorSchemes) {
          return void 0;
        }
        if (colorScheme) {
          theme.colorSchemes[scheme] = {
            ...colorScheme !== true && colorScheme,
            palette: createPalette({
              ...colorScheme === true ? {} : colorScheme.palette,
              mode: scheme
            })
            // cast type to skip module augmentation test
          };
        }
      }
      function createTheme(options = {}, ...args) {
        const {
          palette,
          cssVariables = false,
          colorSchemes: initialColorSchemes = !palette ? {
            light: true
          } : void 0,
          defaultColorScheme: initialDefaultColorScheme = palette == null ? void 0 : palette.mode,
          ...rest
        } = options;
        const defaultColorSchemeInput = initialDefaultColorScheme || "light";
        const defaultScheme = initialColorSchemes == null ? void 0 : initialColorSchemes[defaultColorSchemeInput];
        const colorSchemesInput = {
          ...initialColorSchemes,
          ...palette ? {
            [defaultColorSchemeInput]: {
              ...typeof defaultScheme !== "boolean" && defaultScheme,
              palette
            }
          } : void 0
        };
        if (cssVariables === false) {
          if (!("colorSchemes" in options)) {
            return createThemeNoVars(options, ...args);
          }
          let paletteOptions = palette;
          if (!("palette" in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
              if (colorSchemesInput[defaultColorSchemeInput] !== true) {
                paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
              } else if (defaultColorSchemeInput === "dark") {
                paletteOptions = {
                  mode: "dark"
                };
              }
            }
          }
          const theme = createThemeNoVars({
            ...options,
            palette: paletteOptions
          }, ...args);
          theme.defaultColorScheme = defaultColorSchemeInput;
          theme.colorSchemes = colorSchemesInput;
          if (theme.palette.mode === "light") {
            theme.colorSchemes.light = {
              ...colorSchemesInput.light !== true && colorSchemesInput.light,
              palette: theme.palette
            };
            attachColorScheme(theme, "dark", colorSchemesInput.dark);
          }
          if (theme.palette.mode === "dark") {
            theme.colorSchemes.dark = {
              ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
              palette: theme.palette
            };
            attachColorScheme(theme, "light", colorSchemesInput.light);
          }
          return theme;
        }
        if (!palette && !("light" in colorSchemesInput) && defaultColorSchemeInput === "light") {
          colorSchemesInput.light = true;
        }
        return createThemeWithVars({
          ...rest,
          colorSchemes: colorSchemesInput,
          defaultColorScheme: defaultColorSchemeInput,
          ...typeof cssVariables !== "boolean" && cssVariables
        }, ...args);
      }
      const defaultTheme = exports("i", createTheme());
      function slotShouldForwardProp(prop) {
        return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
      }
      const rootShouldForwardProp = (prop) => slotShouldForwardProp(prop) && prop !== "classes";
      const styled = exports("s", createStyled({
        themeId: THEME_ID,
        defaultTheme,
        rootShouldForwardProp
      }));
      const memoTheme = exports("m", unstable_memoTheme);
      function useDefaultProps(params) {
        return useDefaultProps$1(params);
      }
    }
  };
});
